import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { RangeSlider } from 'rsuite';
import "rsuite/dist/rsuite.css";
import TOPBAR from "../../components/TopBar";
import SEARCHBAR from "../../components/SeachBar";
import MENUBAR from "../../components/Menu";
import FOOTER from "../../components/Footer";
import Pagination from 'react-bootstrap/Pagination';
import { ShimmerThumbnail } from "react-shimmer-effects";
import Collapse from 'react-bootstrap/Collapse';
import WheelTirePackageCard from '../../components/Cards/wheel-tire-package-card';
import UpgradeTirePackageCard from '../../components/Cards/upgrade-tire-package-card';
import Modal from 'react-bootstrap/Modal';


export default function WheelTirePackagesLifted() {
    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
    const PRODUCTS_PER_PAGE = 28;
    const MAX_PAGES_DISPLAY = 10;
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const vehicalDetails = JSON.parse(localStorage.getItem('vehical_details'));
    const variantName = vehicalDetails?.variant_name;

    const upgrade = searchParams.get('upgrade');
    const selectedSku = searchParams.get('sku');
    const selectedDiameter = searchParams.get('diameter');
    const selectedWidth = searchParams.get('width');

    const year = searchParams.get('year');
    const make = searchParams.get('make');
    const model = searchParams.get('model');
    const variant = searchParams.get('variant');

    const [packages, setPackages] = useState([]);
    const [upgradedPackages, setUpgradedPackages] = useState([]);

    // console.log("packages", packages);
    const [stateRestored, setStateRestored] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalProducts, setTotalProducts] = useState(0);
    const [isHidden, setIsHidden] = useState(false);

    const [showInStockOnly, setShowInStockOnly] = useState(true);
    const [sortingValue, setSortingValue] = useState(1);

    // Diameter Filter
    const [diameterArray, setDiameterArray] = useState([]);
    const [availableDiameters, setAvailableDiameters] = useState([]);
    // console.log("availableDiameters",availableDiameters);

    const [openDiameter, setOpenDiameter] = useState(true);

    // Brand Filter
    const [brandArray, setBrandArray] = useState([]);
    const [availableBrands, setAvailableBrands] = useState([]);
    const [openBrand, setOpenBrand] = useState(false);

    // Model Filter
    const [modelArray, setModelArray] = useState([]);
    const [availableModels, setAvailableModels] = useState([]);
    const [openModel, setOpenModel] = useState(false);

    // Width Filter
    const [widthArray, setWidthArray] = useState([]);
    const [availableWidths, setAvailableWidths] = useState([]);
    const [openWidth, setOpenWidth] = useState(false);

    // Offset Filter
    const [offsetArray, setOffsetArray] = useState([]);
    const [availableOffsets, setAvailableOffsets] = useState([]);
    const [openOffset, setOpenOffset] = useState(false);

    // Color Filter
    const [colorArray, setColorArray] = useState([]);
    const [availableColors, setAvailableColors] = useState([]);
    const [openColor, setOpenColor] = useState(false);

    // Price Range
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');
    const [maxPriceLimit, setMaxPriceLimit] = useState(5000);
    const [initialMaxPriceLimit, setInitialMaxPriceLimit] = useState(null);
    const [openPrice, setOpenPrice] = useState(false);


    // Tire Brand Filter
    const [tireBrandArray, setTireBrandArray] = useState([]);
    const [availableTireBrands, setAvailableTireBrands] = useState([]);
    const [openTireBrand, setOpenTireBrand] = useState(true);

    // Tire Model Filter
    const [tireModelArray, setTireModelArray] = useState([]);
    const [availableTireModels, setAvailableTireModels] = useState([]);
    const [openTireModel, setOpenTireModel] = useState(false);

    // Tire Size Filter
    const [tireSizeArray, setTireSizeArray] = useState([]);
    const [availableTireSizes, setAvailableTireSizes] = useState([]);
    const [availableTempTireSizes, setAvailableTempTireSizes] = useState([]);
    // console.log("availableTempTireSizes", availableTempTireSizes);

    const [openTireSize, setOpenTireSize] = useState(false);

    // Price Filter for Upgrade Mode
    const [minTirePrice, setMinTirePrice] = useState('');
    const [maxTirePrice, setMaxTirePrice] = useState('');
    const [maxTirePriceLimit, setMaxTirePriceLimit] = useState(5000);
    const [openTirePrice, setOpenTirePrice] = useState(false);

    // Lifted Options
    const [isLifted, setIsLifted] = useState(false);

    const [openLifted, setOpenLifted] = useState(true);
    const [selectedFitmentType, setSelectedFitmentType] = useState("");
    const [uniqueFitmentNotes, setUniqueFitmentNotes] = useState([]);

    const [tempFitmentType, setTempFitmentType] = useState("");

    // const [isUpgradeMode, setIsUpgradeMode] = useState(false);
    const isUpgradeMode = searchParams.get('upgrade') === 'true';
    // console.log("isUpgradeMode",isUpgradeMode);
    const [selectedWheel, setSelectedWheel] = useState(null);

    const [showLiftedModal, setShowLiftedModal] = useState(false);



    const [applyTrigger, setApplyTrigger] = useState(false);
    const [filterClass, setFilterClass] = useState('');
    const [showMenuSide, setShowMenuSide] = useState("");
    const [vehicleInfo, setVehicleInfo] = useState(null);
    const [cartItems, setCartItems] = useState(0);



    // console.log("vehicleInfo", vehicleInfo);


    const setValueMenuSideBar = (value) => setShowMenuSide(value);

    // Load Cart Count
    // useEffect(() => {
    //     const storedCartItems = localStorage.getItem('totalCartItems');
    //     if (storedCartItems) {
    //         const parsed = JSON.parse(storedCartItems);
    //         const sum = Object.values(parsed).reduce((acc, val) => acc + val, 0);
    //         setCartItems(sum);
    //     }
    // }, []);

    // useEffect(() => {
    //     if (!isUpgradeMode) return;

    //     setTireModelArray(prev =>
    //         prev.filter(model =>
    //             availableTireModels.includes(model)
    //         )
    //     );
    // }, [availableTireModels, isUpgradeMode]);

    // useEffect(() => {
    //     if (!isUpgradeMode) return;

    //     if (tireModelArray.length === 0) return;

    //     const selectedModels = availableTireModels.filter(m =>
    //         tireModelArray.includes(m.model)
    //     );

    //     const uniqueBrands = [
    //         ...new Set(selectedModels.map(m => String(m.brand_id)))
    //     ];

    //     if (uniqueBrands.length === 1) {
    //         setTireBrandArray(uniqueBrands);
    //     }
    // }, [tireModelArray, availableTireModels, isUpgradeMode]);


    useEffect(() => {

        if (isUpgradeMode) {

            setSelectedWheel({
                sku: selectedSku,
                diameter: selectedDiameter,
                width: selectedWidth,
            });

        } else {

            setSelectedWheel(null);

        }

    }, [isUpgradeMode, selectedSku, selectedDiameter, selectedWidth]);

    useEffect(() => {
        const updateCart = () => {
            const storedCartItems = localStorage.getItem('totalCartItems');
            if (storedCartItems) {
                const parsed = JSON.parse(storedCartItems);
                const sum = Object.values(parsed).reduce((acc, val) => acc + val, 0);
                setCartItems(sum);
            }
        };

        updateCart();

        window.addEventListener("cartUpdated", updateCart);

        return () => {
            window.removeEventListener("cartUpdated", updateCart);
        };
    }, []);

    // Load saved fitment type
    // useEffect(() => {
    //     const savedFitment = localStorage.getItem('packages_selectedFitmentType');
    //     if (savedFitment) {
    //         setSelectedFitmentType(savedFitment);
    //         setTempFitmentType(savedFitment);
    //     }
    //     setStateRestored(true);
    // }, []);


    useEffect(() => {
        const savedFitment = localStorage.getItem('packages_selectedFitmentType');
        if (savedFitment) {
            setSelectedFitmentType(savedFitment);
            setTempFitmentType(savedFitment);
        } else {
            // Show ALL by default
            setSelectedFitmentType("ALL");
            setTempFitmentType("ALL");
            localStorage.setItem('packages_selectedFitmentType', "ALL");
        }
        setStateRestored(true);
    }, []);


    // useEffect(() => {
    //     if (stateRestored && isLifted && uniqueFitmentNotes.length > 0 && !selectedFitmentType) {
    //         setShowLiftedModal(true);
    //     }
    // }, [stateRestored, isLifted, uniqueFitmentNotes, selectedFitmentType]);


    // Fetch Packages
    useEffect(() => {

        if (!stateRestored) return;

        if (isLifted && !selectedFitmentType) {
            setPackages([]);
            setTotalProducts(0);
            setTotalPages(1);
            setIsLoading(false);
            return;
        }

        if (isUpgradeMode && (!selectedWheel || !selectedWheel.sku)) {
            return;
        }

        const fetchPackages = async () => {
            setIsLoading(true);
            document.body.classList.add('full-screen-loader');

            try {
                let params = {
                    sorting: sortingValue,
                    inStock: showInStockOnly,
                    fitmentType: selectedFitmentType,
                    upgradeMode: isUpgradeMode,
                    selectedWheelSku: selectedWheel?.sku || '',
                    selectedWheelDiameter: selectedWheel?.diameter || '',
                    selectedWheelWidth: selectedWheel?.width || '',
                };

                if (!isUpgradeMode) {
                    params.limit = PRODUCTS_PER_PAGE;
                    params.page = currentPage;
                }

                if (year && make && model) {
                    params.year = year;
                    params.make = make;
                    params.model = model;
                    params.variant = variant || '';
                    params.variantName = variantName || '';
                }

                if (diameterArray.length > 0) {
                    params.diameter = diameterArray.join(',');
                }
                if (brandArray.length > 0) {
                    params.brand = brandArray.join(',');
                }
                if (modelArray.length > 0) {
                    params.wheelModel = modelArray.join(',');
                }
                if (widthArray.length > 0) {
                    params.width = widthArray.join(',');
                }
                // if (offsetArray.length > 0) {
                //     params.offset = offsetArray.join(',');
                // }
                if (offsetArray.length > 0) {
                    params.wheelOffsetCategory = offsetArray.join(',');
                }
                if (colorArray.length > 0) {
                    params.color = colorArray.join(',');
                }
                if (minPrice > 0 || maxPrice < 5000) {
                    params.minPrice = minPrice;
                    params.maxPrice = maxPrice;
                }

                if (tireBrandArray.length > 0) {
                    params.tireBrand = tireBrandArray.join(',');
                }

                if (tireModelArray.length > 0) {
                    params.tireModel = tireModelArray.join(',');
                }

                if (tireSizeArray.length > 0) {
                    params.tireSize = tireSizeArray.join(',');
                }
                if (minTirePrice > 0 || maxTirePrice < 800) {
                    params.minTirePrice = minTirePrice;
                    params.maxTirePrice = maxTirePrice;
                }

                // const response = await axios.get(`${mainUrl}/api/packages/getWheelTirePackages`, { params });
                const apiUrl = isUpgradeMode
                    ? `${mainUrl}/api/packages/getUpgradeTirePackagesLifted`
                    : `${mainUrl}/api/packages/getWheelTirePackagesLifted`;

                const response = await axios.get(apiUrl, { params });

                // setPackages(response.data.data || []);

                if (isUpgradeMode) {
                    const groupedPackages = Object.values(
                        (response.data.data || []).reduce((acc, item) => {
                            const key = item.sku;
                            if (!acc[key]) {
                                acc[key] = {
                                    wheel: item,
                                    tireOptions: []
                                };
                            }
                            acc[key].tireOptions.push(item);
                            return acc;
                        }, {})
                    );
                    setUpgradedPackages(groupedPackages);
                } else {
                    setPackages(response.data.data || []);
                }

                setTotalPages(response.data.totalPages || 1);
                setTotalProducts(response.data.count || 0);
                setIsHidden(true);

                if (response.data.vehicleInfo) setVehicleInfo(response.data.vehicleInfo);
                if (response.data.availableDiameters) setAvailableDiameters(response.data.availableDiameters);
                if (response.data.availableBrands) setAvailableBrands(response.data.availableBrands);
                if (response.data.availableModels) setAvailableModels(response.data.availableModels);
                if (response.data.availableWidths) setAvailableWidths(response.data.availableWidths);
                if (response.data.availableOffsets) setAvailableOffsets(response.data.availableOffsets);
                if (response.data.availableColors) setAvailableColors(response.data.availableColors);

                if (response.data.availableTempTireSizes) {
                    setAvailableTempTireSizes(response.data.availableTempTireSizes);
                }

                if (response.data.maxPriceLimit) {
                    setMaxPriceLimit(response.data.maxPriceLimit);
                    if (initialMaxPriceLimit === null) {
                        setInitialMaxPriceLimit(Math.ceil(response.data.maxPriceLimit));

                    }
                }

                if (response.data.availableTireBrands) {
                    setAvailableTireBrands(response.data.availableTireBrands);
                }



                // if (response.data.availableTireBrands) {
                //     setAvailableTireBrands(response.data.availableTireBrands);
                //     // ================= ONLY FOR UPGRADE MODE (TIRES) =================
                //     if (isUpgradeMode && response.data.availableTireBrands.length === 1) {
                //         const singleBrandObj = response.data.availableTireBrands[0];
                //         const brandIds = singleBrandObj.ids.map(String);

                //         setTireBrandArray(prev => {
                //             const isAlreadySelected = brandIds.some(id => prev.includes(id));
                //             if (!isAlreadySelected) {
                //                 return [...prev, ...brandIds];
                //             }
                //             return prev;
                //         });
                //     }
                // }

                if (response.data.availableTireModels) {
                    setAvailableTireModels(response.data.availableTireModels);
                }
                if (response.data.availableTireSizes) {
                    setAvailableTireSizes(response.data.availableTireSizes);
                }
                if (response.data.maxTirePriceLimit) {
                    setMaxTirePriceLimit(Math.ceil(response.data.maxTirePriceLimit));
                }

                setIsLifted(response.data.isLifted || false);
                setUniqueFitmentNotes(response.data.liftedOptions || []);

            } catch (err) {
                console.error("Fetch error:", err);
            } finally {
                setIsLoading(false);
                document.body.classList.remove('full-screen-loader');
            }
        };

        fetchPackages();
        window.scrollTo({ top: 400, behavior: 'smooth' });
    }, [currentPage, sortingValue, showInStockOnly, applyTrigger, selectedFitmentType, year, make, model, variant, isUpgradeMode, selectedWheel, stateRestored]);


    const getPageNumbers = () => {
        const totalDisplay = Math.min(totalPages, MAX_PAGES_DISPLAY);
        const middle = Math.ceil(totalDisplay / 2);
        let start = Math.max(1, currentPage - middle + 1);
        if (start + totalDisplay - 1 > totalPages) {
            start = Math.max(1, totalPages - totalDisplay + 1);
        }
        return Array.from({ length: totalDisplay }, (_, i) => start + i);
    };

    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    const handleSorting = (e) => setSortingValue(parseInt(e.target.value));
    const handleStockToggle = () => setShowInStockOnly(prev => !prev);

    const handleDiameterCheckboxChange = (e) => {
        const value = e.target.value;
        setDiameterArray(prev =>
            prev.includes(value) ? prev.filter(d => d !== value) : [...prev, value]
        );
    };

    const handleBrandCheckboxChange = (e) => {
        const value = e.target.value;

        setBrandArray(prev =>
            prev.includes(value)
                ? prev.filter(b => b !== value)
                : [...prev, value]
        );
    };

    const handleModelCheckboxChange = (e) => {
        const value = e.target.value;
        setModelArray(prev =>
            prev.includes(value) ? prev.filter(m => m !== value) : [...prev, value]
        );
    };

    const handleWidthChange = (e) => {
        const value = e.target.value;
        setWidthArray(prev => prev.includes(value) ? prev.filter(w => w !== value) : [...prev, value]);
    };

    // const handleOffsetChange = (e) => {
    //     const value = e.target.value;
    //     setOffsetArray(prev => prev.includes(value) ? prev.filter(o => o !== value) : [...prev, value]);
    // };

    const handleOffsetChange = (e) => {
        const value = e.target.value;
        setOffsetArray(prev =>
            prev.includes(value)
                ? prev.filter(o => o !== value)
                : [...prev, value]
        );
    };

    const handleColorChange = (e) => {
        const value = e.target.value;
        setColorArray(prev => prev.includes(value) ? prev.filter(c => c !== value) : [...prev, value]);
    };

    // const handleTireBrandCheckboxChange = (e) => {
    //     const value = e.target.value;

    //     setTireBrandArray(prev =>
    //         prev.includes(value)
    //             ? prev.filter(b => b !== value)
    //             : [...prev, value]
    //     );
    // };

    const handleTireBrandCheckboxChange = (brandObj) => {
        setTireBrandArray(prev => {
            // Check if any of the brand's IDs are already selected
            const anySelected = brandObj.ids.some(id => prev.includes(String(id)));

            if (anySelected) {
                // Remove all IDs of this brand
                return prev.filter(id => !brandObj.ids.includes(Number(id)));
            } else {
                // Add all IDs of this brand
                return [...prev, ...brandObj.ids.map(String)];
            }
        });
    };

    const handleTireModelCheckboxChange = (e) => {
        const value = e.target.value;

        setTireModelArray(prev =>
            prev.includes(value)
                ? prev.filter(m => m !== value)
                : [...prev, value]
        );
    };

    const handleTireSizeChange = (e) => {
        const value = e.target.value;
        setTireSizeArray(prev =>
            prev.includes(value) ? prev.filter(s => s !== value) : [...prev, value]
        );
    };

    const handleTirePriceRangeChange = ([min, max]) => {
        setMinTirePrice(min);
        setMaxTirePrice(max);
    };


    // Handle Lifted Option Change (Temporary only)
    const handleFitmentTypeChange = (e) => {
        setTempFitmentType(e.target.value);
    };

    // Load upgrade mode
    // useEffect(() => {
    //     const savedUpgradeMode = localStorage.getItem('packages_upgradeMode');

    //     if (savedUpgradeMode === 'true') {
    //         setIsUpgradeMode(true);
    //     }
    // }, []);


    const getPackageKey = (pkg, index) => [
        pkg.sku,
        pkg.tire_item_id,
        pkg.tire_sku,
        pkg.front_wheel_sku,
        pkg.rear_wheel_sku,
        pkg.front_tire_sku,
        pkg.rear_tire_sku,
        pkg.id,
        index
    ].filter(Boolean).join('-');

    // const enableUpgradeMode = (wheelData) => {
    //     setSelectedWheel({
    //         sku: wheelData.sku,
    //         diameter: wheelData.diameter,
    //         width: wheelData.width,
    //         brand_id: wheelData.brand_id,
    //         style: wheelData.style,
    //     });

    //     setIsUpgradeMode(true);

    //     setTireBrandArray([]);
    //     setTireModelArray([]);
    //     setCurrentPage(1);
    // };

    const enableUpgradeMode = (wheelData) => {

        const params = new URLSearchParams({
            year,
            make,
            model,
            variant,
            upgrade: 'true',
            sku: wheelData.sku,
            diameter: wheelData.diameter,
            width: wheelData.width
        });

        navigate(`/wheel-tire-packages/lifted?${params.toString()}`);
    };


    // const enableUpgradeMode = () => {
    //     setIsUpgradeMode(true);
    //     //  localStorage.setItem('packages_upgradeMode', 'true');
    //     setBrandArray([]);
    //     setModelArray([]);
    //     setDiameterArray([]);
    //     setCurrentPage(1);
    // };

    // const disableUpgradeMode = () => {
    //     setIsUpgradeMode(false);
    //     // localStorage.removeItem('packages_upgradeMode');
    //     setTireBrandArray([]);
    //     setTireModelArray([]);
    //     setCurrentPage(1);
    // };

    const disableUpgradeMode = () => {

        const params = new URLSearchParams({
            year,
            make,
            model,
            variant
        });

        navigate(`/wheel-tire-packages/lifted?${params.toString()}`);
    };

    // const handleLiftedSelection = (fitmentId) => {
    //     setSelectedFitmentType(fitmentId);
    //     setTempFitmentType(fitmentId);
    //     localStorage.setItem('packages_selectedFitmentType', fitmentId);
    //     setShowLiftedModal(false);
    //     setApplyTrigger(prev => !prev);
    // };



    // Handle Lifted Option Selection + Clear Filters Logic
    const handleLiftedSelection = (newFitmentId) => {
        const isDifferent = String(newFitmentId) !== String(selectedFitmentType);

        // If user changed to a different option → Clear all filters
        if (isDifferent) {
            clearAllFiltersExceptLifted(newFitmentId);
        } else {
            // Same option selected → just close modal
            setShowLiftedModal(false);
        }
    };


    // New Function: Clear all filters except the new lifted option
    const clearAllFiltersExceptLifted = (newFitmentId) => {
        setDiameterArray([]);
        setBrandArray([]);
        setModelArray([]);
        setWidthArray([]);
        setOffsetArray([]);
        setColorArray([]);
        setMinPrice('');
        setMaxPrice('');
        setTireBrandArray([]);
        setTireModelArray([]);
        setTireSizeArray([]);
        setMinTirePrice('');
        setMaxTirePrice('');

        // Update lifted option
        setSelectedFitmentType(newFitmentId);
        setTempFitmentType(newFitmentId);
        localStorage.setItem('packages_selectedFitmentType', newFitmentId);

        // Close modal and refresh results
        setShowLiftedModal(false);
        setCurrentPage(1);
        setApplyTrigger(prev => !prev);
    };

    const applyFilters = () => {
        setSelectedFitmentType(tempFitmentType);
        localStorage.setItem('packages_selectedFitmentType', tempFitmentType);

        setCurrentPage(1);
        setApplyTrigger(prev => !prev);
        setFilterClass('');
        document.body.classList.remove('home-layout');
    };

    // +++ for auto select brand ++++
    // const applyFilters = () => {
    //     setSelectedFitmentType(tempFitmentType);
    //     localStorage.setItem('packages_selectedFitmentType', tempFitmentType);

    //     if (!isUpgradeMode) {
    //         if (availableBrands && availableBrands.length === 1) {
    //             const singleBrandId = String(availableBrands[0].brand_id);
    //             setBrandArray([singleBrandId]);
    //         }
    //     } else {
    //         if (availableTireBrands && availableTireBrands.length === 1) {
    //             const singleTireBrandObj = availableTireBrands[0];
    //             const brandIds = singleTireBrandObj.ids.map(String);
    //             setTireBrandArray(brandIds);
    //         }
    //     }
    //     setCurrentPage(1);
    //     setApplyTrigger(prev => !prev);
    //     setFilterClass('');
    //     document.body.classList.remove('home-layout');
    // };

    const clearAllFilters = () => {
        setDiameterArray([]);
        setBrandArray([]);
        setModelArray([]);
        setWidthArray([]);
        setOffsetArray([]);
        setColorArray([]);
        setMinPrice('');
        setMaxPrice('');
        setTireBrandArray([])
        setTireModelArray([])
        setTireSizeArray([]);
        // setSelectedFitmentType("");
        // setTempFitmentType("");
        // localStorage.removeItem('packages_selectedFitmentType');
        setShowInStockOnly(true);
        setSortingValue(1);
        setCurrentPage(1);
        setApplyTrigger(prev => !prev);
    };

    // const showFiltersClick = () => {
    //     setFilterClass('active-filter');
    //     document.body.classList.add('home-layout');
    // };

    // const hideFilterClass = () => {
    //     setFilterClass('');
    //     document.body.classList.remove('home-layout');
    // };

    const showFiltersClick = () => {
        setFilterClass('active-filter');
    };

    const hideFilterClass = () => {
        setFilterClass('');
    };

    useEffect(() => {
        const isMobile = window.innerWidth <= 991;

        if (isMobile && filterClass === 'active-filter') {
            document.body.classList.add('home-layout');
        } else {
            document.body.classList.remove('home-layout');
        }

        return () => {
            document.body.classList.remove('home-layout');
        };
    }, [filterClass]);

    const formatTitleName = (str) => {
        if (!str) return '';
        return str
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };


    const startIndex = (currentPage - 1) * PRODUCTS_PER_PAGE + 1;
    const endIndex = Math.min(startIndex + PRODUCTS_PER_PAGE - 1, totalProducts);

    return (
        <>
            <Helmet><title>Wheels & Tires Packages</title></Helmet>

            <TOPBAR isHidden={isHidden} />
            <SEARCHBAR setValueMenuSideBar={setValueMenuSideBar} cartItemsdata={cartItems} />
            <MENUBAR showMenuSide={showMenuSide} setValueMenuSideBar={setValueMenuSideBar} />

            {/* Lifted Option Selection Modal */}
            {/* <Modal
                show={showLiftedModal}
                backdrop="static"
                keyboard={false}
                dialogClassName="lifted-modal"
            >
                <Modal.Header>
                    <Modal.Title>
                        {selectedFitmentType ? "Change Lifted Option" : "Select Lifted Option"}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p className="mb-3">
                        {selectedFitmentType
                            ? "Please select a new lifted configuration:"
                            : "Please select a lifted configuration for your vehicle:"}
                    </p>

                    <div className="d-grid gap-2">
                        {uniqueFitmentNotes.map((item) => (
                            <button
                                key={item.id}
                                className={`btn btn-lg ${String(selectedFitmentType) === String(item.id)
                                    ? 'btn-danger'
                                    : 'btn-outline-danger'}`}
                                onClick={() => handleLiftedSelection(item.id)}
                            >
                                {item.label}
                                {String(selectedFitmentType) === String(item.id)}
                            </button>
                        ))}
                    </div>
                </Modal.Body>

                {selectedFitmentType && (
                    <Modal.Footer>
                        <button
                            className="btn btn-secondary"
                            onClick={() => setShowLiftedModal(false)}
                        >
                            Cancel
                        </button>
                    </Modal.Footer>
                )}
            </Modal> */}

            <Modal
                show={showLiftedModal}
                backdrop="static"
                keyboard={false}
                dialogClassName="lifted-modal"
            >
                <Modal.Header>
                    <Modal.Title>
                        {selectedFitmentType && selectedFitmentType !== "ALL"
                            ? "Change Lifted Option"
                            : "Select Lifted Option"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-3">
                        Please select a lifted configuration for your vehicle:
                    </p>
                    <div className="d-grid gap-2">
                        {/* ALL Option */}
                        <button
                            key="all"
                            className={`btn btn-lg ${selectedFitmentType === "ALL" ? 'btn-danger' : 'btn-outline-danger'}`}
                            onClick={() => handleLiftedSelection("ALL")}
                        >
                            All
                        </button>

                        {uniqueFitmentNotes.map((item) => (
                            <button
                                key={item.id}
                                className={`btn btn-lg ${String(selectedFitmentType) === String(item.id) ? 'btn-danger' : 'btn-outline-danger'}`}
                                onClick={() => handleLiftedSelection(item.id)}
                            >
                                {item.label}
                            </button>
                        ))}
                    </div>
                </Modal.Body>

                {selectedFitmentType && (
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={() => setShowLiftedModal(false)}>
                            Cancel
                        </button>
                    </Modal.Footer>
                )}
            </Modal>

            <div className="main-inner-banner">
                <div className="parformane-bar">
                    <div className="container d-flex justify-content-between">
                        {/* <ul className="p-0 m-0 listing-parmofamne">
                            <li><a href="/">Home /</a></li>
                            <li className="active-bread text-decoration-none"><a href="#">Wheels & Tires Packages</a></li>
                        </ul> */}

                        <ul className="p-0 m-0 listing-parmofamne">
                            <li><a href="/">Home /</a></li>

                            <li className={isUpgradeMode ? "" : "active-bread text-decoration-none"}>
                                {isUpgradeMode ? (
                                    <a href={`/wheel-tire-packages/lifted?year=${year}&make=${make}&model=${model}&variant=${variant}`}>
                                        Wheels & Tires Packages /
                                    </a>
                                ) : (
                                    <a href="#">Wheels & Tires Packages</a>
                                )}
                            </li>

                            {isUpgradeMode && (
                                <li className="active-bread text-decoration-none">
                                    <a href="#">Upgrade Tire</a>
                                </li>
                            )}
                        </ul>

                    </div>
                </div>
                <h2 className="text-center txt-main-listing">Wheels & Tires Packages</h2>
            </div>

            {/* <div>
                {availableTempTireSizes.map((size, index) => (
                    <div key={index}>{JSON.stringify(size)}</div>
                ))}
            </div> */}

            <section className="main-section-lsting">
                <div className="container">
                    {/* Vehicle Title */}
                    {vehicleInfo && (
                        <div className='d-flex car-selection-title mb-3'>
                            <div className='vechicleName'>
                                <strong style={{ fontSize: '30px' }}>
                                    {vehicleInfo.yearId} {vehicleInfo.makeName} {vehicleInfo.modelName} {vehicleInfo.submodelName}
                                </strong>
                            </div>
                        </div>
                    )}

                    {/* Top Lifted Options (Display Only - No filter action here) */}
                    {/* {uniqueFitmentNotes && uniqueFitmentNotes.length > 0 && (
                        <div className='fitmet-type'>
                            <div className="price-filter-fitment">
                                <span className='title'>Lifted Options</span>
                                <div id="fitment-collapse-text-fitment">
                                    <select
                                        className="form-control w-100"
                                        name="wheelFinish"
                                        onChange={handleFitmentTypeChange}
                                        value={tempFitmentType || ''}
                                    >
                                        <option value="">All</option>
                                        {uniqueFitmentNotes.map((item) => (
                                            <option className="ymm-li" value={item.id} key={item.id}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    )} */}

                    {uniqueFitmentNotes && uniqueFitmentNotes.length > 0 && !isUpgradeMode && (
                        <div className="fitmet-type mb-3">
                            <div className="price-filter-fitment">
                                <span className="title">Lifted Options</span>
                                <div id="fitment-collapse-text-fitment">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p className="text-success fw-bold mt-2 mb-1">
                                            {selectedFitmentType === "ALL"
                                                ? "All"
                                                : uniqueFitmentNotes.find(f => String(f.id) === String(selectedFitmentType))?.label}
                                        </p>
                                        <button
                                            className="btn btn-sm btn-danger"
                                            onClick={() => {
                                                hideFilterClass();
                                                setTimeout(() => setShowLiftedModal(true), 200);
                                            }}
                                        >
                                            Edit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row">
                        {/* Sidebar Filters */}
                        <div className="col-lg-3">
                            <div className={`main-outer-filter ${filterClass}`}>

                                <div className="filter-crose" id="close-bar">
                                    <button className="abc" onClick={hideFilterClass}>
                                        <img src="/images/x-mark.svg" alt="img" height="100%" width="100%" />
                                    </button>
                                </div>

                                <div className="price-filter filter-button">
                                    <button className="btn btn-danger" onClick={applyFilters}>
                                        APPLY FILTER
                                    </button>
                                    <p className="filter-note mt-2">
                                        After making your selections, click <strong>"Apply Filter"</strong> to update the results.
                                    </p>
                                </div>

                                {/* Lifted Options in Sidebar */}
                                {/* {uniqueFitmentNotes && uniqueFitmentNotes.length > 0 && !isUpgradeMode && (
                                    <div className="price-filter">
                                        <h3
                                            className="price-filter-text"
                                            role="button"
                                            onClick={() => setOpenLifted(!openLifted)}
                                        >
                                            Lifted Options <i className={openLifted ? "fa fa-minus" : "fa fa-plus"}></i>
                                        </h3>
                                        <Collapse in={openLifted}>
                                            <div className="p-2">
                                                {uniqueFitmentNotes && uniqueFitmentNotes.length > 0 ? (
                                                    <select
                                                        className="form-control w-100"
                                                        onChange={handleFitmentTypeChange}
                                                        value={tempFitmentType || ''}
                                                    >
                                                        <option value="">All</option>
                                                        {uniqueFitmentNotes.map((item) => (
                                                            <option className="ymm-li" value={item.id} key={item.id}>
                                                                {item.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                ) : (
                                                    <ShimmerThumbnail height={10} rounded />
                                                )}
                                            </div>
                                        </Collapse>
                                    </div>
                                )} */}

                                {/* {uniqueFitmentNotes && uniqueFitmentNotes.length > 0 && !isUpgradeMode && (
                                    <div className="price-filter">
                                        <h3 className="price-filter-text">Lifted Option</h3>
                                        <p className="text-success fw-bold">
                                            {uniqueFitmentNotes.find(f => f.id === selectedFitmentType)?.label || 'Not Selected'}
                                        </p>
                                        <small className="text-muted">You can change this from the filter panel</small>
                                    </div>
                                )} */}

                                {/* Lifted Option Display with Edit Button */}
                                {uniqueFitmentNotes && uniqueFitmentNotes.length > 0 && !isUpgradeMode && (
                                    <div className="price-filter">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h3 className="price-filter-text mb-0">Lifted Option</h3>

                                            <button
                                                className="btn btn-sm btn-danger"
                                                // onClick={() => setShowLiftedModal(true)}
                                                onClick={() => {
                                                    hideFilterClass();
                                                    setTimeout(() => {
                                                        setShowLiftedModal(true);
                                                    }, 200);
                                                }}
                                            >
                                                {/* <i className="fa fa-edit me-1"></i>  */}
                                                Edit
                                            </button>
                                        </div>

                                        <p className="text-success fw-bold mt-2 mb-1">
                                            {selectedFitmentType === "ALL"
                                                ? "All"
                                                : uniqueFitmentNotes.find(f => String(f.id) === String(selectedFitmentType))?.label}
                                        </p>
                                    </div>
                                )}

                                {!isUpgradeMode ? (
                                    <>
                                        {/* Diameter Filter */}
                                        <div className="price-filter">
                                            <h3
                                                className="price-filter-text"
                                                role="button"
                                                onClick={() => setOpenDiameter(!openDiameter)}
                                            >
                                                Wheel Diameter <i className={openDiameter ? "fa fa-minus" : "fa fa-plus"}></i>
                                            </h3>
                                            <Collapse in={openDiameter}>
                                                <ul className="p-0 m-0 list-filter">
                                                    {availableDiameters.length > 0 ? (
                                                        availableDiameters.map((dia) => (
                                                            <li key={dia}>
                                                                <label className="label-filter">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`dia-${dia}`}
                                                                        value={dia}
                                                                        className="filter-box"
                                                                        checked={diameterArray.includes(dia.toString())}
                                                                        onChange={handleDiameterCheckboxChange}
                                                                    />
                                                                    {dia + '"'}
                                                                    <label htmlFor={`dia-${dia}`} className="custome-checkboxes"></label>
                                                                </label>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <ShimmerThumbnail height={10} rounded />
                                                    )}
                                                </ul>
                                            </Collapse>
                                        </div>

                                        {/* Width Filter */}
                                        <div className="price-filter">
                                            <h3
                                                className="price-filter-text"
                                                role="button"
                                                onClick={() => setOpenWidth(!openWidth)}
                                            >
                                                Wheel Width <i className={openWidth ? "fa fa-minus" : "fa fa-plus"}></i>
                                            </h3>

                                            <Collapse in={openWidth}>
                                                <ul className="p-0 m-0 list-filter">
                                                    {availableWidths.map((w) => (
                                                        <li key={w}>
                                                            <label className="label-filter">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`width-${w}`}
                                                                    value={w}
                                                                    className="filter-box"
                                                                    checked={widthArray.includes(w.toString())}
                                                                    onChange={handleWidthChange}
                                                                />
                                                                {w}"
                                                                <label
                                                                    htmlFor={`width-${w}`}
                                                                    className="custome-checkboxes"
                                                                ></label>
                                                            </label>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </Collapse>
                                        </div>
                                        {/* Brand Filter */}
                                        <div className="price-filter">
                                            <h3
                                                className="price-filter-text"
                                                role="button"
                                                onClick={() => setOpenBrand(!openBrand)}
                                            >
                                                Brand <i className={openBrand ? "fa fa-minus" : "fa fa-plus"}></i>
                                            </h3>
                                            <Collapse in={openBrand}>
                                                <ul className="p-0 m-0 list-filter">
                                                    {availableBrands.length > 0 ? (
                                                        availableBrands.map((brand) => (
                                                            <li key={brand.brand_id}>
                                                                <label className="label-filter">

                                                                    <input
                                                                        type="checkbox"
                                                                        id={`brand-${brand.brand_id}`}
                                                                        value={brand.brand_id}
                                                                        className="filter-box"
                                                                        checked={brandArray.includes(String(brand.brand_id))}
                                                                        onChange={handleBrandCheckboxChange}
                                                                    />

                                                                    {brand.brand_desc}

                                                                    <label
                                                                        htmlFor={`brand-${brand.brand_id}`}
                                                                        className="custome-checkboxes"
                                                                    ></label>

                                                                </label>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <ShimmerThumbnail height={10} rounded />
                                                    )}
                                                </ul>
                                            </Collapse>
                                        </div>

                                        {/* Model Filter */}
                                        <div className="price-filter">
                                            <h3
                                                className="price-filter-text"
                                                role="button"
                                                onClick={() => setOpenModel(!openModel)}
                                            >
                                                Model <i className={openModel ? "fa fa-minus" : "fa fa-plus"}></i>
                                            </h3>
                                            <Collapse in={openModel}>
                                                <ul className="p-0 m-0 list-filter">
                                                    {availableModels.length > 0 ? (
                                                        availableModels.map((mod) => (
                                                            <li key={mod}>
                                                                <label className="label-filter">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`mod-${mod}`}
                                                                        value={mod}
                                                                        className="filter-box"
                                                                        checked={modelArray.includes(mod)}
                                                                        onChange={handleModelCheckboxChange}
                                                                    />
                                                                    {mod}
                                                                    <label htmlFor={`mod-${mod}`} className="custome-checkboxes"></label>

                                                                </label>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <ShimmerThumbnail height={10} rounded />
                                                    )}
                                                </ul>
                                            </Collapse>
                                        </div>

                                        {/* Offset Filter */}
                                        {/* <div className="price-filter">
                                            <h3
                                                className="price-filter-text"
                                                role="button"
                                                onClick={() => setOpenOffset(!openOffset)}
                                            >
                                                Wheel Offset <i className={openOffset ? "fa fa-minus" : "fa fa-plus"}></i>
                                            </h3>

                                            <Collapse in={openOffset}>
                                                <ul className="p-0 m-0 list-filter">
                                                    {availableOffsets.map((off) => (
                                                        <li key={off}>
                                                            <label className="label-filter">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`offset-${off}`}
                                                                    value={off}
                                                                    className="filter-box"
                                                                    checked={offsetArray.includes(off.toString())}
                                                                    onChange={handleOffsetChange}
                                                                />
                                                                {off}
                                                                <label
                                                                    htmlFor={`offset-${off}`}
                                                                    className="custome-checkboxes"
                                                                ></label>
                                                            </label>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </Collapse>
                                        </div> */}


                                        <div className="price-filter">
                                            <h3
                                                className="price-filter-text"
                                                role="button"
                                                onClick={() => setOpenOffset(!openOffset)}
                                            >
                                                Wheel Offset <i className={openOffset ? "fa fa-minus" : "fa fa-plus"}></i>
                                            </h3>

                                            <Collapse in={openOffset}>
                                                <ul className="p-0 m-0 list-filter">
                                                    <li>
                                                        <label className="label-filter">
                                                            <input
                                                                type="checkbox"
                                                                id="negative"
                                                                value="negative"
                                                                className="filter-box"
                                                                checked={offsetArray.includes("negative")}
                                                                onChange={handleOffsetChange}   // Reuse existing handler
                                                            />
                                                            Negative
                                                            <label htmlFor="negative" className="custome-checkboxes"></label>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className="label-filter">
                                                            <input
                                                                type="checkbox"
                                                                id="low"
                                                                value="low"
                                                                className="filter-box"
                                                                checked={offsetArray.includes("low")}
                                                                onChange={handleOffsetChange}
                                                            />
                                                            Low (0-15)
                                                            <label htmlFor="low" className="custome-checkboxes"></label>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className="label-filter">
                                                            <input
                                                                type="checkbox"
                                                                id="medium"
                                                                value="medium"
                                                                className="filter-box"
                                                                checked={offsetArray.includes("medium")}
                                                                onChange={handleOffsetChange}
                                                            />
                                                            Medium (15-30)
                                                            <label htmlFor="medium" className="custome-checkboxes"></label>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className="label-filter">
                                                            <input
                                                                type="checkbox"
                                                                id="high"
                                                                value="high"
                                                                className="filter-box"
                                                                checked={offsetArray.includes("high")}
                                                                onChange={handleOffsetChange}
                                                            />
                                                            High (30-45)
                                                            <label htmlFor="high" className="custome-checkboxes"></label>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label className="label-filter">
                                                            <input
                                                                type="checkbox"
                                                                id="veryHigh"
                                                                value="veryHigh"
                                                                className="filter-box"
                                                                checked={offsetArray.includes("veryHigh")}
                                                                onChange={handleOffsetChange}
                                                            />
                                                            Very High (45+)
                                                            <label htmlFor="veryHigh" className="custome-checkboxes"></label>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </Collapse>
                                        </div>

                                        {/* Color Filter */}
                                        <div className="price-filter">
                                            <h3
                                                className="price-filter-text"
                                                role="button"
                                                onClick={() => setOpenColor(!openColor)}
                                            >
                                                Finish <i className={openColor ? "fa fa-minus" : "fa fa-plus"}></i>
                                            </h3>

                                            <Collapse in={openColor}>
                                                <ul className="p-0 m-0 list-filter">
                                                    {availableColors.map((color) => (
                                                        <li key={color}>
                                                            <label className="label-filter">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`color-${color}`}
                                                                    value={color}
                                                                    className="filter-box"
                                                                    checked={colorArray.includes(color)}
                                                                    onChange={handleColorChange}
                                                                />
                                                                {formatTitleName(color)}
                                                                <label
                                                                    htmlFor={`color-${color}`}
                                                                    className="custome-checkboxes"
                                                                ></label>
                                                            </label>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </Collapse>
                                        </div>

                                        {/* Price Range Filter */}
                                        <div className="price-filter">
                                            <h3
                                                className="price-filter-text"
                                                role="button"
                                                onClick={() => setOpenPrice(!openPrice)}
                                            >
                                                Package Price <i className={openPrice ? "fa fa-minus" : "fa fa-plus"}></i>
                                            </h3>

                                            <Collapse in={openPrice}>
                                                <div className="p-2">
                                                    <div className="d-flex justify-content-between mb-5">
                                                        <span className="text-muted small">$0</span>
                                                        <span className="text-muted small">${initialMaxPriceLimit}</span>
                                                    </div>

                                                    <RangeSlider
                                                        min={0}
                                                        max={initialMaxPriceLimit}
                                                        step={1}
                                                        value={[Number(minPrice) || 0, Number(maxPrice) || initialMaxPriceLimit]}
                                                        onChange={([min, max]) => {
                                                            setMinPrice(min);
                                                            setMaxPrice(max);
                                                        }}
                                                        tooltip={true}
                                                    />
                                                </div>
                                            </Collapse>
                                        </div>

                                        <p className="filter-note">
                                            After making your selections, click <strong>"Apply Filter"</strong> to update the results.
                                        </p>

                                        <div className="price-filter filter-button">
                                            <div>
                                                <button className='btn btn-danger' onClick={applyFilters}>APPLY FILTER</button>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {/* Tire Brand Filter */}
                                        <div className="price-filter">
                                            <h3
                                                className="price-filter-text"
                                                role="button"
                                                onClick={() => setOpenTireBrand(!openTireBrand)}
                                            >
                                                Tire Brand <i className={openTireBrand ? "fa fa-minus" : "fa fa-plus"}></i>
                                            </h3>

                                            {/* <Collapse in={openTireBrand}>
                                                <ul className="p-0 m-0 list-filter">

                                                    {availableTireBrands.length > 0 ? (
                                                        availableTireBrands.map((brandObj) => (
                                                            <li key={brandObj.brand_id}>
                                                                <label className="label-filter">

                                                                    <input
                                                                        type="checkbox"
                                                                        id={`tire-brand-${brandObj.brand_id}`}
                                                                        value={brandObj.brand_id}
                                                                        className="filter-box"
                                                                        checked={tireBrandArray.includes(String(brandObj.brand_id))}
                                                                        onChange={handleTireBrandCheckboxChange}
                                                                    />

                                                                    {brandObj.brand}

                                                                    <label
                                                                        htmlFor={`tire-brand-${brandObj.brand_id}`}
                                                                        className="custome-checkboxes"
                                                                    ></label>

                                                                </label>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <ShimmerThumbnail height={10} rounded />
                                                    )}

                                                </ul>
                                            </Collapse> */}

                                            <Collapse in={openTireBrand}>
                                                <ul className="p-0 m-0 list-filter">
                                                    {availableTireBrands.length > 0 ? (
                                                        availableTireBrands.map((brandObj) => (
                                                            <li key={brandObj.brand}>
                                                                <label className="label-filter">

                                                                    <input
                                                                        type="checkbox"
                                                                        id={`tire-brand-${brandObj.brand}`}
                                                                        value={brandObj.ids.join(',')}
                                                                        className="filter-box"
                                                                        // checked if any ID of this brand is in the selected array
                                                                        checked={brandObj.ids.some(id => tireBrandArray.includes(String(id)))}
                                                                        onChange={() => handleTireBrandCheckboxChange(brandObj)}
                                                                    />

                                                                    {brandObj.brand}

                                                                    <label
                                                                        htmlFor={`tire-brand-${brandObj.brand}`}
                                                                        className="custome-checkboxes"
                                                                    ></label>

                                                                </label>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <ShimmerThumbnail height={10} rounded />
                                                    )}
                                                </ul>
                                            </Collapse>


                                        </div>

                                        {/* Tire Model Filter */}
                                        <div className="price-filter">
                                            <h3
                                                className="price-filter-text"
                                                role="button"
                                                onClick={() => setOpenTireModel(!openTireModel)}
                                            >
                                                Tire Model <i className={openTireModel ? "fa fa-minus" : "fa fa-plus"}></i>
                                            </h3>

                                            <Collapse in={openTireModel}>
                                                <ul className="p-0 m-0 list-filter">
                                                    {availableTireModels.map((model) => (
                                                        <li key={model}>
                                                            <label className="label-filter">

                                                                <input
                                                                    type="checkbox"
                                                                    id={`tire-model-${model}`}
                                                                    value={model}
                                                                    checked={tireModelArray.includes(model)}
                                                                    onChange={handleTireModelCheckboxChange}
                                                                    className="filter-box"
                                                                />

                                                                {formatTitleName(model)}

                                                                <label
                                                                    htmlFor={`tire-model-${model}`}
                                                                    className="custome-checkboxes"
                                                                ></label>

                                                            </label>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </Collapse>
                                        </div>

                                        {/* Tire Size Filter */}
                                        <div className="price-filter">
                                            <h3
                                                className="price-filter-text"
                                                role="button"
                                                onClick={() => setOpenTireSize(!openTireSize)}
                                            >
                                                Tire Size <i className={openTireSize ? "fa fa-minus" : "fa fa-plus"}></i>
                                            </h3>

                                            <Collapse in={openTireSize}>
                                                <ul className="p-0 m-0 list-filter">
                                                    {availableTireSizes.length > 0 ? (
                                                        availableTireSizes.map((size) => (
                                                            <li key={size}>
                                                                <label className="label-filter">
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`tire-size-${size}`}
                                                                        value={size}
                                                                        className="filter-box"
                                                                        checked={tireSizeArray.includes(size)}
                                                                        onChange={handleTireSizeChange}
                                                                    />
                                                                    {size}
                                                                    <label
                                                                        htmlFor={`tire-size-${size}`}
                                                                        className="custome-checkboxes"
                                                                    ></label>
                                                                </label>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <ShimmerThumbnail height={10} rounded />
                                                    )}
                                                </ul>
                                            </Collapse>
                                        </div>

                                        <div className="price-filter">
                                            <h3
                                                className="price-filter-text"
                                                role="button"
                                                onClick={() => setOpenTirePrice(!openTirePrice)}
                                            >
                                                Tire Price <i className={openTirePrice ? "fa fa-minus" : "fa fa-plus"}></i>
                                            </h3>

                                            <Collapse in={openTirePrice}>
                                                <div className="p-2">
                                                    <div className="d-flex justify-content-between mb-5">
                                                        <span className="text-muted small">$0</span>
                                                        <span className="text-muted small">${maxTirePriceLimit}</span>
                                                    </div>

                                                    <RangeSlider
                                                        min={0}
                                                        max={maxTirePriceLimit}
                                                        step={1}
                                                        value={[Number(minTirePrice) || 0, Number(maxTirePrice) || maxTirePriceLimit]}
                                                        onChange={handleTirePriceRangeChange}
                                                        tooltip={true}
                                                    />

                                                </div>
                                            </Collapse>
                                        </div>

                                        <p className="filter-note">
                                            After making your selections, click <strong>"Apply Filter"</strong> to update the results.
                                        </p>

                                        <div className="price-filter filter-button">
                                            <div>
                                                <button className='btn btn-danger' onClick={applyFilters}>APPLY FILTER</button>
                                            </div>
                                        </div>


                                    </>
                                )}


                            </div>
                        </div>

                        {/* Main Content */}
                        <div className="col-lg-9 filter-for-mobile">

                            <div className='selectedFilters mb-3'>

                                {/* ================= NORMAL FILTER CHIPS ================= */}
                                {!isUpgradeMode && (
                                    <>
                                        {/* Diameter Chips */}
                                        {diameterArray.map(dia => (
                                            <span className="span-filter-Checkbox m-1" key={dia}>
                                                {dia + '"'}
                                                <i
                                                    className="fa fa-times"
                                                    onClick={() =>
                                                        setDiameterArray(prev => prev.filter(d => d !== dia))
                                                    }
                                                ></i>
                                            </span>
                                        ))}

                                        {/* Brand Chips */}
                                        {brandArray.map((brandId) => {
                                            const brandObj = availableBrands.find(
                                                b => String(b.brand_id) === String(brandId)
                                            );

                                            return (
                                                <span className="span-filter-Checkbox m-1" key={brandId}>
                                                    {brandObj?.brand_desc}

                                                    <i
                                                        className="fa fa-times"
                                                        onClick={() =>
                                                            setBrandArray(prev =>
                                                                prev.filter(b => b !== brandId)
                                                            )
                                                        }
                                                    ></i>
                                                </span>
                                            );
                                        })}


                                        {/* Model Chips */}
                                        {modelArray.map(mod => (
                                            <span className="span-filter-Checkbox m-1" key={mod}>
                                                {mod}

                                                <i
                                                    className="fa fa-times"
                                                    onClick={() =>
                                                        setModelArray(prev =>
                                                            prev.filter(m => m !== mod)
                                                        )
                                                    }
                                                ></i>
                                            </span>
                                        ))}

                                        {/* Width Chips */}
                                        {widthArray.map(w => (
                                            <span className="span-filter-Checkbox m-1" key={w}>
                                                {w}
                                                <i className="fa fa-times" onClick={() => setWidthArray(prev => prev.filter(ww => ww !== w))}></i>
                                            </span>
                                        ))}

                                        {/* Offset Chips */}
                                        {/* {offsetArray.map(off => (
                                            <span className="span-filter-Checkbox m-1" key={off}>
                                                {off}
                                                <i className="fa fa-times" onClick={() => setOffsetArray(prev => prev.filter(o => o !== off))}></i>
                                            </span>
                                        ))} */}

                                        {offsetArray.map(cat => (
                                            <span className="span-filter-Checkbox m-1" key={cat}>
                                                {cat === 'negative' && 'Negative'}
                                                {cat === 'low' && 'Low (0-15)'}
                                                {cat === 'medium' && 'Medium (15-30)'}
                                                {cat === 'high' && 'High (30-45)'}
                                                {cat === 'veryHigh' && 'Very High (45+)'}
                                                <i
                                                    className="fa fa-times"
                                                    onClick={() => setOffsetArray(prev => prev.filter(c => c !== cat))}
                                                ></i>
                                            </span>
                                        ))}

                                        {/* Color Chips */}
                                        {colorArray.map(color => (
                                            <span className="span-filter-Checkbox m-1" key={color}>
                                                {color}
                                                <i className="fa fa-times" onClick={() => setColorArray(prev => prev.filter(c => c !== color))}></i>
                                            </span>
                                        ))}
                                    </>
                                )}

                                {/* ================= TIRE FILTER CHIPS ================= */}
                                {isUpgradeMode && (
                                    <>
                                        {/* Tire Brand Chips */}
                                        {/* {tireBrandArray.map((brandId) => {

                                            const brandObj = availableTireBrands.find(
                                                b => String(b.brand_id) === String(brandId)
                                            );

                                            return (
                                                <span className="span-filter-Checkbox m-1" key={brandId}>

                                                    {brandObj?.brand}

                                                    <i
                                                        className="fa fa-times"
                                                        onClick={() =>
                                                            setTireBrandArray(prev =>
                                                                prev.filter(b => b !== brandId)
                                                            )
                                                        }
                                                    ></i>

                                                </span>
                                            );
                                        })} */}

                                        {tireBrandArray.length > 0 &&
                                            availableTireBrands
                                                .filter(b => b.ids.some(id => tireBrandArray.includes(String(id))))
                                                .map(brandObj => (
                                                    <span className="span-filter-Checkbox m-1" key={brandObj.brand}>
                                                        {brandObj.brand}
                                                        <i
                                                            className="fa fa-times"
                                                            onClick={() =>
                                                                setTireBrandArray(prev =>
                                                                    prev.filter(id => !brandObj.ids.map(String).includes(id))
                                                                )
                                                            }
                                                        ></i>
                                                    </span>
                                                ))
                                        }

                                        {/* Tire Model Chips */}
                                        {tireModelArray.map((model) => (
                                            <span className="span-filter-Checkbox m-1" key={model}>
                                                {formatTitleName(model)}

                                                <i
                                                    className="fa fa-times"
                                                    onClick={() =>
                                                        setTireModelArray(prev =>
                                                            prev.filter(m => m !== model)
                                                        )
                                                    }
                                                ></i>
                                            </span>
                                        ))}

                                        {tireSizeArray.map((size) => (
                                            <span className="span-filter-Checkbox m-1" key={size}>
                                                {size}
                                                <i className="fa fa-times" onClick={() => setTireSizeArray(prev => prev.filter(s => s !== size))}></i>
                                            </span>
                                        ))}
                                    </>
                                )}

                                {/* ================= CLEAR FILTER ================= */}
                                {(
                                    (!isUpgradeMode &&
                                        (
                                            diameterArray.length > 0 ||
                                            brandArray.length > 0 ||
                                            modelArray.length > 0 ||
                                            widthArray.length > 0 ||
                                            offsetArray.length > 0 ||
                                            colorArray.length > 0
                                        )
                                    ) ||
                                    (isUpgradeMode &&
                                        (
                                            tireBrandArray.length > 0 ||
                                            tireModelArray.length > 0 ||
                                            tireSizeArray.length > 0
                                        )
                                    )
                                ) && (
                                        <span
                                            className="clearFilterStyle ms-2"
                                            onClick={clearAllFilters}
                                        >
                                            Clear filters
                                        </span>
                                    )}
                            </div>

                            {/* Sort & Stock Controls */}
                            <div className="d-flex justify-content-end filters-sort-by">
                                <div>
                                    {totalProducts > 0 && !isUpgradeMode && (
                                        <p className="px-5">
                                            Showing {startIndex} - {endIndex} of {parseInt(totalProducts).toLocaleString('en-US')} packages
                                        </p>
                                    )}
                                </div>

                                {/* <div className="stockCheckbox">
                                    <ul className="stockCheckboxUl">
                                        <li>
                                            <input
                                                type="checkbox"
                                                className="tgl tgl-light"
                                                id="stockCheckPackage"
                                                checked={!showInStockOnly}
                                                onChange={handleStockToggle}
                                            />
                                            <label htmlFor="stockCheckPackage" className="tgl-btn"></label>
                                        </li>
                                        <li className="staggeredLi">
                                            {showInStockOnly ? <span>In Stock Items</span> : <span>All Items</span>}
                                        </li>
                                    </ul>
                                </div> */}

                                {/* <div className="sorting-section">
                                    <select className="form-control" value={sortingValue} onChange={handleSorting}>
                                        <option value={1}>Low-High</option>
                                        <option value={2}>High-Low</option>
                                    </select>
                                </div> */}

                                {!isUpgradeMode && (
                                    <div className="sorting-section">
                                        <select className="form-control" value={sortingValue} onChange={handleSorting}>
                                            <option value={1}>Low-High</option>
                                            <option value={2}>High-Low</option>
                                        </select>
                                    </div>
                                )}

                                <div className="main-headin">
                                    <div className="main-filter-resposive">
                                        <button className="mobile-filter-btn" onClick={showFiltersClick}> <svg className="me-1" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" key="svg-icon">
                                            <path d="M5.25901 14.35L5.25888 14.35C5.24769 14.3502 5.23405 14.3476 5.21863 14.339L5.21836 14.3389C5.19936 14.3282 5.19074 14.318 5.18703 14.3124C5.17887 14.2972 5.176 14.2839 5.176 14.2707V7.91365C5.176 7.82275 5.1652 7.72056 5.13235 7.61486C5.09945 7.50839 5.04961 7.41561 4.99386 7.33726L0.724519 1.26892C0.724485 1.26887 0.724451 1.26882 0.724418 1.26877C0.676725 1.20083 0.65495 1.13291 0.650688 1.06991C0.64665 1.00345 0.660203 0.933143 0.696549 0.863781L0.696552 0.863774C0.732993 0.794228 0.783357 0.74264 0.84197 0.707465L0.841971 0.707466L0.843135 0.706765C0.902543 0.670943 0.973036 0.65 1.05357 0.65H12.9463C13.0271 0.65 13.0973 0.670932 13.1564 0.706609L13.1578 0.70745C13.2164 0.742594 13.2667 0.794096 13.3032 0.863535C13.3407 0.935416 13.3534 1.00516 13.3492 1.06874C13.345 1.13245 13.3232 1.20066 13.2755 1.26862C13.2755 1.26872 13.2754 1.26882 13.2753 1.26892L9.0045 7.33779L9.00402 7.33848C8.94618 7.42089 8.90098 7.51067 8.86985 7.6068L8.86979 7.60678L8.8672 7.61518C8.83481 7.71999 8.82355 7.82177 8.82355 7.91441V12.1555C8.82355 12.1724 8.81984 12.1838 8.81525 12.1923C8.81075 12.1999 8.8025 12.2101 8.78506 12.2207L8.34805 12.4857L8.34827 12.4864L5.3042 14.3361C5.30409 14.3362 5.30399 14.3362 5.30388 14.3363C5.28736 14.3462 5.27261 14.3497 5.25901 14.35ZM5.27154 14.9999C5.14389 15.0023 5.01635 14.9707 4.90099 14.9061L5.27154 14.9999Z" stroke="#E81C2E" strokeWidth="1.3"></path>
                                        </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>



                            {/* Packages Grid */}
                            {/* <div className="row">
                                {isLoading ? (
                                    Array.from({ length: 6 }).map((_, i) => (
                                        <div className="col-lg-6 col-md-12 mb-4" key={i}>
                                            <ShimmerThumbnail height={300} rounded />
                                        </div>
                                    ))
                                ) : packages.length > 0 ? (
                                    packages.map((pkg, index) => (
                                        <div className="col-lg-6 col-md-12 mb-4" key={getPackageKey(pkg, index)}>
                                            <WheelTirePackageCard
                                                packageData={pkg}
                                                enableUpgradeMode={enableUpgradeMode}
                                                isUpgradeMode={isUpgradeMode}
                                            />
                                        </div>
                                    ))
                                ) : (
                                    <div className='container m-0 text-center py-5'>
                                        <h1>No Product Found</h1>
                                        <p>Sorry, we couldn't find any Wheel & Tire Packages.</p>
                                        <p><a href='/' className='btn btn-sm btn-danger'>Go to Homepage</a></p>
                                    </div>
                                )}
                            </div> */}

                            <div className="row">
                                {isLoading ? (

                                    Array.from({ length: 6 }).map((_, i) => (
                                        <div className="col-lg-6 col-md-12 mb-4" key={i}>
                                            <ShimmerThumbnail height={300} rounded />
                                        </div>
                                    ))

                                ) : (

                                    !isUpgradeMode ? (

                                        packages.length > 0 ? (

                                            packages.map((pkg, index) => (
                                                <div
                                                    className="col-lg-6 col-md-12 mb-4"
                                                    key={getPackageKey(pkg, index)}
                                                >
                                                    <WheelTirePackageCard
                                                        packageData={pkg}
                                                        enableUpgradeMode={enableUpgradeMode}
                                                        isUpgradeMode={false}
                                                    />
                                                </div>
                                            ))

                                        ) : (

                                            <div className="container m-0 text-center py-5">
                                                <h1>No Product Found</h1>
                                                <p>Sorry, we couldn't find any Wheel & Tire Packages.</p>
                                                <p>
                                                    <a href="/" className="btn btn-sm btn-danger">
                                                        Go to Homepage
                                                    </a>
                                                </p>
                                            </div>

                                        )

                                    ) : (

                                        upgradedPackages.length > 0 ? (

                                            upgradedPackages.map((pkg, index) => (
                                                <div
                                                    className="col-lg-12 mb-4"
                                                    key={`${pkg.wheel.sku}-${index}`}
                                                >
                                                    <UpgradeTirePackageCard
                                                        packageData={pkg}
                                                        isUpgradeMode={true}
                                                    />
                                                </div>
                                            ))

                                        ) : (

                                            <div className="container m-0 text-center py-5">
                                                <h1>No Product Found</h1>
                                                <p>Sorry, we couldn't find any Upgrade Tire Packages.</p>
                                                <p>
                                                    <a href="/" className="btn btn-sm btn-danger">
                                                        Go to Homepage
                                                    </a>
                                                </p>
                                            </div>

                                        )

                                    )

                                )}
                            </div>

                            {/* Pagination */}
                            {!isUpgradeMode && totalPages > 1 && (
                                <div className="d-flex justify-content-center mt-5">
                                    <Pagination>
                                        <Pagination.First disabled={currentPage === 1} onClick={() => handlePageChange(1)} />
                                        <Pagination.Prev disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)} />
                                        {getPageNumbers().map(page => (
                                            <Pagination.Item
                                                key={page}
                                                active={page === currentPage}
                                                onClick={() => handlePageChange(page)}
                                            >
                                                {page}
                                            </Pagination.Item>
                                        ))}
                                        <Pagination.Next disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)} />
                                        <Pagination.Last disabled={currentPage === totalPages} onClick={() => handlePageChange(totalPages)} />
                                    </Pagination>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            <FOOTER />
        </>
    );
}









// import React, { useState, useEffect } from 'react';
// import { Helmet } from 'react-helmet';
// import { useSearchParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { RangeSlider } from 'rsuite';
// import "rsuite/dist/rsuite.css";
// import TOPBAR from "../../components/TopBar";
// import SEARCHBAR from "../../components/SeachBar";
// import MENUBAR from "../../components/Menu";
// import FOOTER from "../../components/Footer";
// import Pagination from 'react-bootstrap/Pagination';
// import { ShimmerThumbnail } from "react-shimmer-effects";
// import Collapse from 'react-bootstrap/Collapse';
// import WheelTirePackageCard from '../../components/Cards/wheel-tire-package-card';
// import UpgradeTirePackageCard from '../../components/Cards/upgrade-tire-package-card';




// export default function WheelTirePackagesLifted() {
//     const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
//     const PRODUCTS_PER_PAGE = 28;
//     const MAX_PAGES_DISPLAY = 10;
//     const navigate = useNavigate();
//     const [searchParams] = useSearchParams();



//     const upgrade = searchParams.get('upgrade');
//     const selectedSku = searchParams.get('sku');
//     const selectedDiameter = searchParams.get('diameter');
//     const selectedWidth = searchParams.get('width');

//     const year = searchParams.get('year');
//     const make = searchParams.get('make');
//     const model = searchParams.get('model');
//     const variant = searchParams.get('variant');

//     const [packages, setPackages] = useState([]);
//     const [upgradedPackages, setUpgradedPackages] = useState([]);

//     // console.log("packages", packages);
//     const [stateRestored, setStateRestored] = useState(false);

//     const [isLoading, setIsLoading] = useState(true);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//     const [totalProducts, setTotalProducts] = useState(0);
//     const [isHidden, setIsHidden] = useState(false);

//     const [showInStockOnly, setShowInStockOnly] = useState(true);
//     const [sortingValue, setSortingValue] = useState(1);

//     // Diameter Filter
//     const [diameterArray, setDiameterArray] = useState([]);
//     const [availableDiameters, setAvailableDiameters] = useState([]);
//     // console.log("availableDiameters",availableDiameters);

//     const [openDiameter, setOpenDiameter] = useState(true);

//     // Brand Filter
//     const [brandArray, setBrandArray] = useState([]);
//     const [availableBrands, setAvailableBrands] = useState([]);
//     const [openBrand, setOpenBrand] = useState(false);

//     // Model Filter
//     const [modelArray, setModelArray] = useState([]);
//     const [availableModels, setAvailableModels] = useState([]);
//     const [openModel, setOpenModel] = useState(false);

//     // Width Filter
//     const [widthArray, setWidthArray] = useState([]);
//     const [availableWidths, setAvailableWidths] = useState([]);
//     const [openWidth, setOpenWidth] = useState(false);

//     // Offset Filter
//     const [offsetArray, setOffsetArray] = useState([]);
//     const [availableOffsets, setAvailableOffsets] = useState([]);
//     const [openOffset, setOpenOffset] = useState(false);

//     // Color Filter
//     const [colorArray, setColorArray] = useState([]);
//     const [availableColors, setAvailableColors] = useState([]);
//     const [openColor, setOpenColor] = useState(false);

//     // Price Range
//     const [minPrice, setMinPrice] = useState('');
//     const [maxPrice, setMaxPrice] = useState('');
//     const [maxPriceLimit, setMaxPriceLimit] = useState(5000);
//     const [initialMaxPriceLimit, setInitialMaxPriceLimit] = useState(null);
//     const [openPrice, setOpenPrice] = useState(false);


//     // Tire Brand Filter
//     const [tireBrandArray, setTireBrandArray] = useState([]);
//     const [availableTireBrands, setAvailableTireBrands] = useState([]);
//     const [openTireBrand, setOpenTireBrand] = useState(true);

//     // Tire Model Filter
//     const [tireModelArray, setTireModelArray] = useState([]);
//     const [availableTireModels, setAvailableTireModels] = useState([]);
//     const [openTireModel, setOpenTireModel] = useState(false);

//     // Tire Size Filter
//     const [tireSizeArray, setTireSizeArray] = useState([]);
//     const [availableTireSizes, setAvailableTireSizes] = useState([]);
//     const [openTireSize, setOpenTireSize] = useState(false);

//     // Price Filter for Upgrade Mode
//     const [minTirePrice, setMinTirePrice] = useState('');
//     const [maxTirePrice, setMaxTirePrice] = useState('');
//     const [maxTirePriceLimit, setMaxTirePriceLimit] = useState(5000);
//     const [openTirePrice, setOpenTirePrice] = useState(false);

//     // Lifted Options
//     const [isLifted, setIsLifted] = useState(false);
//     const [openLifted, setOpenLifted] = useState(true);
//     const [selectedFitmentType, setSelectedFitmentType] = useState("");
//     const [uniqueFitmentNotes, setUniqueFitmentNotes] = useState([]);

//     const [tempFitmentType, setTempFitmentType] = useState("");

//     // const [isUpgradeMode, setIsUpgradeMode] = useState(false);
//     const isUpgradeMode = searchParams.get('upgrade') === 'true';
//     // console.log("isUpgradeMode",isUpgradeMode);
//     const [selectedWheel, setSelectedWheel] = useState(null);



//     const [applyTrigger, setApplyTrigger] = useState(false);
//     const [filterClass, setFilterClass] = useState('');
//     const [showMenuSide, setShowMenuSide] = useState("");
//     const [vehicleInfo, setVehicleInfo] = useState(null);
//     const [cartItems, setCartItems] = useState(0);



//     // console.log("vehicleInfo", vehicleInfo);


//     const setValueMenuSideBar = (value) => setShowMenuSide(value);

//     // Load Cart Count
//     // useEffect(() => {
//     //     const storedCartItems = localStorage.getItem('totalCartItems');
//     //     if (storedCartItems) {
//     //         const parsed = JSON.parse(storedCartItems);
//     //         const sum = Object.values(parsed).reduce((acc, val) => acc + val, 0);
//     //         setCartItems(sum);
//     //     }
//     // }, []);

//     // useEffect(() => {
//     //     if (!isUpgradeMode) return;

//     //     setTireModelArray(prev =>
//     //         prev.filter(model =>
//     //             availableTireModels.includes(model)
//     //         )
//     //     );
//     // }, [availableTireModels, isUpgradeMode]);

//     // useEffect(() => {
//     //     if (!isUpgradeMode) return;

//     //     if (tireModelArray.length === 0) return;

//     //     const selectedModels = availableTireModels.filter(m =>
//     //         tireModelArray.includes(m.model)
//     //     );

//     //     const uniqueBrands = [
//     //         ...new Set(selectedModels.map(m => String(m.brand_id)))
//     //     ];

//     //     if (uniqueBrands.length === 1) {
//     //         setTireBrandArray(uniqueBrands);
//     //     }
//     // }, [tireModelArray, availableTireModels, isUpgradeMode]);


//     useEffect(() => {

//         if (isUpgradeMode) {

//             setSelectedWheel({
//                 sku: selectedSku,
//                 diameter: selectedDiameter,
//                 width: selectedWidth,
//             });

//         } else {

//             setSelectedWheel(null);

//         }

//     }, [isUpgradeMode, selectedSku, selectedDiameter, selectedWidth]);

//     useEffect(() => {
//         const updateCart = () => {
//             const storedCartItems = localStorage.getItem('totalCartItems');
//             if (storedCartItems) {
//                 const parsed = JSON.parse(storedCartItems);
//                 const sum = Object.values(parsed).reduce((acc, val) => acc + val, 0);
//                 setCartItems(sum);
//             }
//         };

//         updateCart();

//         window.addEventListener("cartUpdated", updateCart);

//         return () => {
//             window.removeEventListener("cartUpdated", updateCart);
//         };
//     }, []);

//     // Load saved fitment type
//     // useEffect(() => {
//     //     const savedFitment = localStorage.getItem('packages_selectedFitmentType');
//     //     if (savedFitment) {
//     //         setSelectedFitmentType(savedFitment);
//     //         setTempFitmentType(savedFitment);
//     //     }
//     // }, []);

//     // Load saved fitment type
//     useEffect(() => {
//         const savedFitment = localStorage.getItem('packages_selectedFitmentType');
//         if (savedFitment) {
//             setSelectedFitmentType(savedFitment);
//             setTempFitmentType(savedFitment);
//         }
//         setStateRestored(true);
//     }, []);

//     // Fetch Packages
//     useEffect(() => {

//         if (!stateRestored) return;

//         if (isUpgradeMode && (!selectedWheel || !selectedWheel.sku)) {
//             return;
//         }

//         const fetchPackages = async () => {
//             setIsLoading(true);
//             document.body.classList.add('full-screen-loader');

//             try {
//                 let params = {
//                     sorting: sortingValue,
//                     inStock: showInStockOnly,
//                     fitmentType: selectedFitmentType,
//                     upgradeMode: isUpgradeMode,
//                     selectedWheelSku: selectedWheel?.sku || '',
//                     selectedWheelDiameter: selectedWheel?.diameter || '',
//                     selectedWheelWidth: selectedWheel?.width || '',
//                 };

//                 if (!isUpgradeMode) {
//                     params.limit = PRODUCTS_PER_PAGE;
//                     params.page = currentPage;
//                 }

//                 if (year && make && model) {
//                     params.year = year;
//                     params.make = make;
//                     params.model = model;
//                     params.variant = variant || '';
//                 }

//                 if (diameterArray.length > 0) {
//                     params.diameter = diameterArray.join(',');
//                 }
//                 if (brandArray.length > 0) {
//                     params.brand = brandArray.join(',');
//                 }
//                 if (modelArray.length > 0) {
//                     params.wheelModel = modelArray.join(',');
//                 }
//                 if (widthArray.length > 0) {
//                     params.width = widthArray.join(',');
//                 }
//                 // if (offsetArray.length > 0) {
//                 //     params.offset = offsetArray.join(',');
//                 // }
//                 if (offsetArray.length > 0) {
//                     params.wheelOffsetCategory = offsetArray.join(',');
//                 }
//                 if (colorArray.length > 0) {
//                     params.color = colorArray.join(',');
//                 }
//                 if (minPrice > 0 || maxPrice < 5000) {
//                     params.minPrice = minPrice;
//                     params.maxPrice = maxPrice;
//                 }

//                 if (tireBrandArray.length > 0) {
//                     params.tireBrand = tireBrandArray.join(',');
//                 }

//                 if (tireModelArray.length > 0) {
//                     params.tireModel = tireModelArray.join(',');
//                 }

//                 if (tireSizeArray.length > 0) {
//                     params.tireSize = tireSizeArray.join(',');
//                 }
//                 if (minTirePrice > 0 || maxTirePrice < 800) {
//                     params.minTirePrice = minTirePrice;
//                     params.maxTirePrice = maxTirePrice;
//                 }

//                 // const response = await axios.get(`${mainUrl}/api/packages/getWheelTirePackages`, { params });
//                 const apiUrl = isUpgradeMode
//                     ? `${mainUrl}/api/packages/getUpgradeTirePackagesLifted`
//                     : `${mainUrl}/api/packages/getWheelTirePackagesLifted`;

//                 const response = await axios.get(apiUrl, { params });

//                 // setPackages(response.data.data || []);

//                 if (isUpgradeMode) {
//                     const groupedPackages = Object.values(
//                         (response.data.data || []).reduce((acc, item) => {
//                             const key = item.sku;
//                             if (!acc[key]) {
//                                 acc[key] = {
//                                     wheel: item,
//                                     tireOptions: []
//                                 };
//                             }
//                             acc[key].tireOptions.push(item);
//                             return acc;
//                         }, {})
//                     );
//                     setUpgradedPackages(groupedPackages);
//                 } else {
//                     setPackages(response.data.data || []);
//                 }

//                 setTotalPages(response.data.totalPages || 1);
//                 setTotalProducts(response.data.count || 0);
//                 setIsHidden(true);

//                 if (response.data.vehicleInfo) setVehicleInfo(response.data.vehicleInfo);
//                 if (response.data.availableDiameters) setAvailableDiameters(response.data.availableDiameters);
//                 if (response.data.availableBrands) setAvailableBrands(response.data.availableBrands);
//                 if (response.data.availableModels) setAvailableModels(response.data.availableModels);
//                 if (response.data.availableWidths) setAvailableWidths(response.data.availableWidths);
//                 if (response.data.availableOffsets) setAvailableOffsets(response.data.availableOffsets);
//                 if (response.data.availableColors) setAvailableColors(response.data.availableColors);

//                 if (response.data.maxPriceLimit) {
//                     setMaxPriceLimit(response.data.maxPriceLimit);
//                     if (initialMaxPriceLimit === null) {
//                         setInitialMaxPriceLimit(Math.ceil(response.data.maxPriceLimit));

//                     }
//                 }

//                 if (response.data.availableTireBrands) {
//                     setAvailableTireBrands(response.data.availableTireBrands);
//                 }



//                 // if (response.data.availableTireBrands) {
//                 //     setAvailableTireBrands(response.data.availableTireBrands);
//                 //     // ================= ONLY FOR UPGRADE MODE (TIRES) =================
//                 //     if (isUpgradeMode && response.data.availableTireBrands.length === 1) {
//                 //         const singleBrandObj = response.data.availableTireBrands[0];
//                 //         const brandIds = singleBrandObj.ids.map(String);

//                 //         setTireBrandArray(prev => {
//                 //             const isAlreadySelected = brandIds.some(id => prev.includes(id));
//                 //             if (!isAlreadySelected) {
//                 //                 return [...prev, ...brandIds];
//                 //             }
//                 //             return prev;
//                 //         });
//                 //     }
//                 // }

//                 if (response.data.availableTireModels) {
//                     setAvailableTireModels(response.data.availableTireModels);
//                 }
//                 if (response.data.availableTireSizes) {
//                     setAvailableTireSizes(response.data.availableTireSizes);
//                 }
//                 if (response.data.maxTirePriceLimit) {
//                     setMaxTirePriceLimit(Math.ceil(response.data.maxTirePriceLimit));
//                 }

//                 setIsLifted(response.data.isLifted || false);
//                 setUniqueFitmentNotes(response.data.liftedOptions || []);

//             } catch (err) {
//                 console.error("Fetch error:", err);
//             } finally {
//                 setIsLoading(false);
//                 document.body.classList.remove('full-screen-loader');
//             }
//         };

//         fetchPackages();
//         window.scrollTo({ top: 400, behavior: 'smooth' });
//     }, [currentPage, sortingValue, showInStockOnly, applyTrigger, selectedFitmentType, year, make, model, variant, isUpgradeMode, selectedWheel, stateRestored]);


//     const getPageNumbers = () => {
//         const totalDisplay = Math.min(totalPages, MAX_PAGES_DISPLAY);
//         const middle = Math.ceil(totalDisplay / 2);
//         let start = Math.max(1, currentPage - middle + 1);
//         if (start + totalDisplay - 1 > totalPages) {
//             start = Math.max(1, totalPages - totalDisplay + 1);
//         }
//         return Array.from({ length: totalDisplay }, (_, i) => start + i);
//     };

//     const handlePageChange = (page) => {
//         if (page < 1 || page > totalPages) return;
//         setCurrentPage(page);
//     };

//     const handleSorting = (e) => setSortingValue(parseInt(e.target.value));
//     const handleStockToggle = () => setShowInStockOnly(prev => !prev);

//     const handleDiameterCheckboxChange = (e) => {
//         const value = e.target.value;
//         setDiameterArray(prev =>
//             prev.includes(value) ? prev.filter(d => d !== value) : [...prev, value]
//         );
//     };

//     const handleBrandCheckboxChange = (e) => {
//         const value = e.target.value;

//         setBrandArray(prev =>
//             prev.includes(value)
//                 ? prev.filter(b => b !== value)
//                 : [...prev, value]
//         );
//     };

//     const handleModelCheckboxChange = (e) => {
//         const value = e.target.value;
//         setModelArray(prev =>
//             prev.includes(value) ? prev.filter(m => m !== value) : [...prev, value]
//         );
//     };

//     const handleWidthChange = (e) => {
//         const value = e.target.value;
//         setWidthArray(prev => prev.includes(value) ? prev.filter(w => w !== value) : [...prev, value]);
//     };

//     // const handleOffsetChange = (e) => {
//     //     const value = e.target.value;
//     //     setOffsetArray(prev => prev.includes(value) ? prev.filter(o => o !== value) : [...prev, value]);
//     // };

//     const handleOffsetChange = (e) => {
//         const value = e.target.value;
//         setOffsetArray(prev =>
//             prev.includes(value)
//                 ? prev.filter(o => o !== value)
//                 : [...prev, value]
//         );
//     };

//     const handleColorChange = (e) => {
//         const value = e.target.value;
//         setColorArray(prev => prev.includes(value) ? prev.filter(c => c !== value) : [...prev, value]);
//     };

//     // const handleTireBrandCheckboxChange = (e) => {
//     //     const value = e.target.value;

//     //     setTireBrandArray(prev =>
//     //         prev.includes(value)
//     //             ? prev.filter(b => b !== value)
//     //             : [...prev, value]
//     //     );
//     // };

//     const handleTireBrandCheckboxChange = (brandObj) => {
//         setTireBrandArray(prev => {
//             // Check if any of the brand's IDs are already selected
//             const anySelected = brandObj.ids.some(id => prev.includes(String(id)));

//             if (anySelected) {
//                 // Remove all IDs of this brand
//                 return prev.filter(id => !brandObj.ids.includes(Number(id)));
//             } else {
//                 // Add all IDs of this brand
//                 return [...prev, ...brandObj.ids.map(String)];
//             }
//         });
//     };

//     const handleTireModelCheckboxChange = (e) => {
//         const value = e.target.value;

//         setTireModelArray(prev =>
//             prev.includes(value)
//                 ? prev.filter(m => m !== value)
//                 : [...prev, value]
//         );
//     };

//     const handleTireSizeChange = (e) => {
//         const value = e.target.value;
//         setTireSizeArray(prev =>
//             prev.includes(value) ? prev.filter(s => s !== value) : [...prev, value]
//         );
//     };

//     const handleTirePriceRangeChange = ([min, max]) => {
//         setMinTirePrice(min);
//         setMaxTirePrice(max);
//     };


//     // Handle Lifted Option Change (Temporary only)
//     const handleFitmentTypeChange = (e) => {
//         setTempFitmentType(e.target.value);
//     };

//     // Load upgrade mode
//     // useEffect(() => {
//     //     const savedUpgradeMode = localStorage.getItem('packages_upgradeMode');

//     //     if (savedUpgradeMode === 'true') {
//     //         setIsUpgradeMode(true);
//     //     }
//     // }, []);


//     const getPackageKey = (pkg, index) => [
//         pkg.sku,
//         pkg.tire_item_id,
//         pkg.tire_sku,
//         pkg.front_wheel_sku,
//         pkg.rear_wheel_sku,
//         pkg.front_tire_sku,
//         pkg.rear_tire_sku,
//         pkg.id,
//         index
//     ].filter(Boolean).join('-');

//     // const enableUpgradeMode = (wheelData) => {
//     //     setSelectedWheel({
//     //         sku: wheelData.sku,
//     //         diameter: wheelData.diameter,
//     //         width: wheelData.width,
//     //         brand_id: wheelData.brand_id,
//     //         style: wheelData.style,
//     //     });

//     //     setIsUpgradeMode(true);

//     //     setTireBrandArray([]);
//     //     setTireModelArray([]);
//     //     setCurrentPage(1);
//     // };

//     const enableUpgradeMode = (wheelData) => {

//         const params = new URLSearchParams({
//             year,
//             make,
//             model,
//             variant,
//             upgrade: 'true',
//             sku: wheelData.sku,
//             diameter: wheelData.diameter,
//             width: wheelData.width
//         });

//         navigate(`/wheel-tire-packages/lifted?${params.toString()}`);
//     };


//     // const enableUpgradeMode = () => {
//     //     setIsUpgradeMode(true);
//     //     //  localStorage.setItem('packages_upgradeMode', 'true');
//     //     setBrandArray([]);
//     //     setModelArray([]);
//     //     setDiameterArray([]);
//     //     setCurrentPage(1);
//     // };

//     // const disableUpgradeMode = () => {
//     //     setIsUpgradeMode(false);
//     //     // localStorage.removeItem('packages_upgradeMode');
//     //     setTireBrandArray([]);
//     //     setTireModelArray([]);
//     //     setCurrentPage(1);
//     // };

//     const disableUpgradeMode = () => {

//         const params = new URLSearchParams({
//             year,
//             make,
//             model,
//             variant
//         });

//         navigate(`/wheel-tire-packages/lifted?${params.toString()}`);
//     };

//     const applyFilters = () => {
//         setSelectedFitmentType(tempFitmentType);
//         localStorage.setItem('packages_selectedFitmentType', tempFitmentType);

//         setCurrentPage(1);
//         setApplyTrigger(prev => !prev);
//         setFilterClass('');
//         document.body.classList.remove('home-layout');
//     };

//     // +++ for auto select brand ++++
//     // const applyFilters = () => {
//     //     setSelectedFitmentType(tempFitmentType);
//     //     localStorage.setItem('packages_selectedFitmentType', tempFitmentType);

//     //     if (!isUpgradeMode) {
//     //         if (availableBrands && availableBrands.length === 1) {
//     //             const singleBrandId = String(availableBrands[0].brand_id);
//     //             setBrandArray([singleBrandId]);
//     //         }
//     //     } else {
//     //         if (availableTireBrands && availableTireBrands.length === 1) {
//     //             const singleTireBrandObj = availableTireBrands[0];
//     //             const brandIds = singleTireBrandObj.ids.map(String);
//     //             setTireBrandArray(brandIds);
//     //         }
//     //     }
//     //     setCurrentPage(1);
//     //     setApplyTrigger(prev => !prev);
//     //     setFilterClass('');
//     //     document.body.classList.remove('home-layout');
//     // };

//     const clearAllFilters = () => {
//         setDiameterArray([]);
//         setBrandArray([]);
//         setModelArray([]);
//         setWidthArray([]);
//         setOffsetArray([]);
//         setColorArray([]);
//         setMinPrice('');
//         setMaxPrice('');
//         setTireBrandArray([])
//         setTireModelArray([])
//         setTireSizeArray([]);
//         setSelectedFitmentType("");
//         setTempFitmentType("");
//         localStorage.removeItem('packages_selectedFitmentType');
//         setShowInStockOnly(true);
//         setSortingValue(1);
//         setCurrentPage(1);
//         setApplyTrigger(prev => !prev);
//     };

//     const showFiltersClick = () => {
//         setFilterClass('active-filter');
//         document.body.classList.add('home-layout');
//     };

//     const hideFilterClass = () => {
//         setFilterClass('');
//         document.body.classList.remove('home-layout');
//     };

//     const formatTitleName = (str) => {
//         if (!str) return '';
//         return str
//             .toLowerCase()
//             .split(' ')
//             .map(word => word.charAt(0).toUpperCase() + word.slice(1))
//             .join(' ');
//     };


//     const startIndex = (currentPage - 1) * PRODUCTS_PER_PAGE + 1;
//     const endIndex = Math.min(startIndex + PRODUCTS_PER_PAGE - 1, totalProducts);

//     return (
//         <>
//             <Helmet><title>Wheels & Tires Packages</title></Helmet>

//             <TOPBAR isHidden={isHidden} />
//             <SEARCHBAR setValueMenuSideBar={setValueMenuSideBar} cartItemsdata={cartItems} />
//             <MENUBAR showMenuSide={showMenuSide} setValueMenuSideBar={setValueMenuSideBar} />

//             <div className="main-inner-banner">
//                 <div className="parformane-bar">
//                     <div className="container d-flex justify-content-between">
//                         {/* <ul className="p-0 m-0 listing-parmofamne">
//                             <li><a href="/">Home /</a></li>
//                             <li className="active-bread text-decoration-none"><a href="#">Wheels & Tires Packages</a></li>
//                         </ul> */}

//                         <ul className="p-0 m-0 listing-parmofamne">
//                             <li><a href="/">Home /</a></li>

//                             <li className={isUpgradeMode ? "" : "active-bread text-decoration-none"}>
//                                 {isUpgradeMode ? (
//                                     <a href={`/wheel-tire-packages/lifted?year=${year}&make=${make}&model=${model}&variant=${variant}`}>
//                                         Wheels & Tires Packages /
//                                     </a>
//                                 ) : (
//                                     <a href="#">Wheels & Tires Packages</a>
//                                 )}
//                             </li>

//                             {isUpgradeMode && (
//                                 <li className="active-bread text-decoration-none">
//                                     <a href="#">Upgrade Tire</a>
//                                 </li>
//                             )}
//                         </ul>

//                     </div>
//                 </div>
//                 <h2 className="text-center txt-main-listing">Wheels & Tires Packages</h2>
//             </div>

//             <section className="main-section-lsting">
//                 <div className="container">
//                     {/* Vehicle Title */}
//                     {vehicleInfo && (
//                         <div className='d-flex car-selection-title mb-3'>
//                             <div className='vechicleName'>
//                                 <strong style={{ fontSize: '30px' }}>
//                                     {vehicleInfo.yearId} {vehicleInfo.makeName} {vehicleInfo.modelName} {vehicleInfo.submodelName}
//                                 </strong>
//                             </div>
//                         </div>
//                     )}

//                     {/* Top Lifted Options (Display Only - No filter action here) */}
//                     {/* {uniqueFitmentNotes && uniqueFitmentNotes.length > 0 && (
//                         <div className='fitmet-type'>
//                             <div className="price-filter-fitment">
//                                 <span className='title'>Lifted Options</span>
//                                 <div id="fitment-collapse-text-fitment">
//                                     <select
//                                         className="form-control w-100"
//                                         name="wheelFinish"
//                                         onChange={handleFitmentTypeChange}
//                                         value={tempFitmentType || ''}
//                                     >
//                                         <option value="">All</option>
//                                         {uniqueFitmentNotes.map((item) => (
//                                             <option className="ymm-li" value={item.id} key={item.id}>
//                                                 {item.label}
//                                             </option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>
//                         </div>
//                     )} */}

//                     <div className="row">
//                         {/* Sidebar Filters */}
//                         <div className="col-lg-3">
//                             <div className={`main-outer-filter ${filterClass}`}>

//                                 <div className="filter-crose" id="close-bar">
//                                     <button className="abc" onClick={hideFilterClass}>
//                                         <img src="/images/x-mark.svg" alt="img" height="100%" width="100%" />
//                                     </button>
//                                 </div>

//                                 <div className="price-filter filter-button">
//                                     <button className="btn btn-danger" onClick={applyFilters}>
//                                         APPLY FILTER
//                                     </button>
//                                 </div>

//                                 {/* Lifted Options in Sidebar */}
//                                 {uniqueFitmentNotes && uniqueFitmentNotes.length > 0 && !isUpgradeMode && (
//                                     <div className="price-filter">
//                                         <h3
//                                             className="price-filter-text"
//                                             role="button"
//                                             onClick={() => setOpenLifted(!openLifted)}
//                                         >
//                                             Lifted Options <i className={openLifted ? "fa fa-minus" : "fa fa-plus"}></i>
//                                         </h3>
//                                         <Collapse in={openLifted}>
//                                             <div className="p-2">
//                                                 {uniqueFitmentNotes && uniqueFitmentNotes.length > 0 ? (
//                                                     <select
//                                                         className="form-control w-100"
//                                                         onChange={handleFitmentTypeChange}
//                                                         value={tempFitmentType || ''}
//                                                     >
//                                                         <option value="">All</option>
//                                                         {uniqueFitmentNotes.map((item) => (
//                                                             <option className="ymm-li" value={item.id} key={item.id}>
//                                                                 {item.label}
//                                                             </option>
//                                                         ))}
//                                                     </select>
//                                                 ) : (
//                                                     <ShimmerThumbnail height={10} rounded />
//                                                 )}
//                                             </div>
//                                         </Collapse>
//                                     </div>
//                                 )}

//                                 {!isUpgradeMode ? (
//                                     <>
//                                         {/* Diameter Filter */}
//                                         <div className="price-filter">
//                                             <h3
//                                                 className="price-filter-text"
//                                                 role="button"
//                                                 onClick={() => setOpenDiameter(!openDiameter)}
//                                             >
//                                                 Wheel Diameter <i className={openDiameter ? "fa fa-minus" : "fa fa-plus"}></i>
//                                             </h3>
//                                             <Collapse in={openDiameter}>
//                                                 <ul className="p-0 m-0 list-filter">
//                                                     {availableDiameters.length > 0 ? (
//                                                         availableDiameters.map((dia) => (
//                                                             <li key={dia}>
//                                                                 <label className="label-filter">
//                                                                     <input
//                                                                         type="checkbox"
//                                                                         id={`dia-${dia}`}
//                                                                         value={dia}
//                                                                         className="filter-box"
//                                                                         checked={diameterArray.includes(dia.toString())}
//                                                                         onChange={handleDiameterCheckboxChange}
//                                                                     />
//                                                                     {dia + '"'}
//                                                                     <label htmlFor={`dia-${dia}`} className="custome-checkboxes"></label>
//                                                                 </label>
//                                                             </li>
//                                                         ))
//                                                     ) : (
//                                                         <ShimmerThumbnail height={10} rounded />
//                                                     )}
//                                                 </ul>
//                                             </Collapse>
//                                         </div>

//                                         {/* Width Filter */}
//                                         <div className="price-filter">
//                                             <h3
//                                                 className="price-filter-text"
//                                                 role="button"
//                                                 onClick={() => setOpenWidth(!openWidth)}
//                                             >
//                                                 Wheel Width <i className={openWidth ? "fa fa-minus" : "fa fa-plus"}></i>
//                                             </h3>

//                                             <Collapse in={openWidth}>
//                                                 <ul className="p-0 m-0 list-filter">
//                                                     {availableWidths.map((w) => (
//                                                         <li key={w}>
//                                                             <label className="label-filter">
//                                                                 <input
//                                                                     type="checkbox"
//                                                                     id={`width-${w}`}
//                                                                     value={w}
//                                                                     className="filter-box"
//                                                                     checked={widthArray.includes(w.toString())}
//                                                                     onChange={handleWidthChange}
//                                                                 />
//                                                                 {w}"
//                                                                 <label
//                                                                     htmlFor={`width-${w}`}
//                                                                     className="custome-checkboxes"
//                                                                 ></label>
//                                                             </label>
//                                                         </li>
//                                                     ))}
//                                                 </ul>
//                                             </Collapse>
//                                         </div>
//                                         {/* Brand Filter */}
//                                         <div className="price-filter">
//                                             <h3
//                                                 className="price-filter-text"
//                                                 role="button"
//                                                 onClick={() => setOpenBrand(!openBrand)}
//                                             >
//                                                 Brand <i className={openBrand ? "fa fa-minus" : "fa fa-plus"}></i>
//                                             </h3>
//                                             <Collapse in={openBrand}>
//                                                 <ul className="p-0 m-0 list-filter">
//                                                     {availableBrands.length > 0 ? (
//                                                         availableBrands.map((brand) => (
//                                                             <li key={brand.brand_id}>
//                                                                 <label className="label-filter">

//                                                                     <input
//                                                                         type="checkbox"
//                                                                         id={`brand-${brand.brand_id}`}
//                                                                         value={brand.brand_id}
//                                                                         className="filter-box"
//                                                                         checked={brandArray.includes(String(brand.brand_id))}
//                                                                         onChange={handleBrandCheckboxChange}
//                                                                     />

//                                                                     {brand.brand_desc}

//                                                                     <label
//                                                                         htmlFor={`brand-${brand.brand_id}`}
//                                                                         className="custome-checkboxes"
//                                                                     ></label>

//                                                                 </label>
//                                                             </li>
//                                                         ))
//                                                     ) : (
//                                                         <ShimmerThumbnail height={10} rounded />
//                                                     )}
//                                                 </ul>
//                                             </Collapse>
//                                         </div>

//                                         {/* Model Filter */}
//                                         <div className="price-filter">
//                                             <h3
//                                                 className="price-filter-text"
//                                                 role="button"
//                                                 onClick={() => setOpenModel(!openModel)}
//                                             >
//                                                 Model <i className={openModel ? "fa fa-minus" : "fa fa-plus"}></i>
//                                             </h3>
//                                             <Collapse in={openModel}>
//                                                 <ul className="p-0 m-0 list-filter">
//                                                     {availableModels.length > 0 ? (
//                                                         availableModels.map((mod) => (
//                                                             <li key={mod}>
//                                                                 <label className="label-filter">
//                                                                     <input
//                                                                         type="checkbox"
//                                                                         id={`mod-${mod}`}
//                                                                         value={mod}
//                                                                         className="filter-box"
//                                                                         checked={modelArray.includes(mod)}
//                                                                         onChange={handleModelCheckboxChange}
//                                                                     />
//                                                                     {mod}
//                                                                     <label htmlFor={`mod-${mod}`} className="custome-checkboxes"></label>

//                                                                 </label>
//                                                             </li>
//                                                         ))
//                                                     ) : (
//                                                         <ShimmerThumbnail height={10} rounded />
//                                                     )}
//                                                 </ul>
//                                             </Collapse>
//                                         </div>

//                                         {/* Offset Filter */}
//                                         {/* <div className="price-filter">
//                                             <h3
//                                                 className="price-filter-text"
//                                                 role="button"
//                                                 onClick={() => setOpenOffset(!openOffset)}
//                                             >
//                                                 Wheel Offset <i className={openOffset ? "fa fa-minus" : "fa fa-plus"}></i>
//                                             </h3>

//                                             <Collapse in={openOffset}>
//                                                 <ul className="p-0 m-0 list-filter">
//                                                     {availableOffsets.map((off) => (
//                                                         <li key={off}>
//                                                             <label className="label-filter">
//                                                                 <input
//                                                                     type="checkbox"
//                                                                     id={`offset-${off}`}
//                                                                     value={off}
//                                                                     className="filter-box"
//                                                                     checked={offsetArray.includes(off.toString())}
//                                                                     onChange={handleOffsetChange}
//                                                                 />
//                                                                 {off}
//                                                                 <label
//                                                                     htmlFor={`offset-${off}`}
//                                                                     className="custome-checkboxes"
//                                                                 ></label>
//                                                             </label>
//                                                         </li>
//                                                     ))}
//                                                 </ul>
//                                             </Collapse>
//                                         </div> */}


//                                         <div className="price-filter">
//                                             <h3
//                                                 className="price-filter-text"
//                                                 role="button"
//                                                 onClick={() => setOpenOffset(!openOffset)}
//                                             >
//                                                 Wheel Offset <i className={openOffset ? "fa fa-minus" : "fa fa-plus"}></i>
//                                             </h3>

//                                             <Collapse in={openOffset}>
//                                                 <ul className="p-0 m-0 list-filter">
//                                                     <li>
//                                                         <label className="label-filter">
//                                                             <input
//                                                                 type="checkbox"
//                                                                 id="negative"
//                                                                 value="negative"
//                                                                 className="filter-box"
//                                                                 checked={offsetArray.includes("negative")}
//                                                                 onChange={handleOffsetChange}   // Reuse existing handler
//                                                             />
//                                                             Negative
//                                                             <label htmlFor="negative" className="custome-checkboxes"></label>
//                                                         </label>
//                                                     </li>
//                                                     <li>
//                                                         <label className="label-filter">
//                                                             <input
//                                                                 type="checkbox"
//                                                                 id="low"
//                                                                 value="low"
//                                                                 className="filter-box"
//                                                                 checked={offsetArray.includes("low")}
//                                                                 onChange={handleOffsetChange}
//                                                             />
//                                                             Low (0-15)
//                                                             <label htmlFor="low" className="custome-checkboxes"></label>
//                                                         </label>
//                                                     </li>
//                                                     <li>
//                                                         <label className="label-filter">
//                                                             <input
//                                                                 type="checkbox"
//                                                                 id="medium"
//                                                                 value="medium"
//                                                                 className="filter-box"
//                                                                 checked={offsetArray.includes("medium")}
//                                                                 onChange={handleOffsetChange}
//                                                             />
//                                                             Medium (15-30)
//                                                             <label htmlFor="medium" className="custome-checkboxes"></label>
//                                                         </label>
//                                                     </li>
//                                                     <li>
//                                                         <label className="label-filter">
//                                                             <input
//                                                                 type="checkbox"
//                                                                 id="high"
//                                                                 value="high"
//                                                                 className="filter-box"
//                                                                 checked={offsetArray.includes("high")}
//                                                                 onChange={handleOffsetChange}
//                                                             />
//                                                             High (30-45)
//                                                             <label htmlFor="high" className="custome-checkboxes"></label>
//                                                         </label>
//                                                     </li>
//                                                     <li>
//                                                         <label className="label-filter">
//                                                             <input
//                                                                 type="checkbox"
//                                                                 id="veryHigh"
//                                                                 value="veryHigh"
//                                                                 className="filter-box"
//                                                                 checked={offsetArray.includes("veryHigh")}
//                                                                 onChange={handleOffsetChange}
//                                                             />
//                                                             Very High (45+)
//                                                             <label htmlFor="veryHigh" className="custome-checkboxes"></label>
//                                                         </label>
//                                                     </li>
//                                                 </ul>
//                                             </Collapse>
//                                         </div>

//                                         {/* Color Filter */}
//                                         <div className="price-filter">
//                                             <h3
//                                                 className="price-filter-text"
//                                                 role="button"
//                                                 onClick={() => setOpenColor(!openColor)}
//                                             >
//                                                 Finish <i className={openColor ? "fa fa-minus" : "fa fa-plus"}></i>
//                                             </h3>

//                                             <Collapse in={openColor}>
//                                                 <ul className="p-0 m-0 list-filter">
//                                                     {availableColors.map((color) => (
//                                                         <li key={color}>
//                                                             <label className="label-filter">
//                                                                 <input
//                                                                     type="checkbox"
//                                                                     id={`color-${color}`}
//                                                                     value={color}
//                                                                     className="filter-box"
//                                                                     checked={colorArray.includes(color)}
//                                                                     onChange={handleColorChange}
//                                                                 />
//                                                                 {formatTitleName(color)}
//                                                                 <label
//                                                                     htmlFor={`color-${color}`}
//                                                                     className="custome-checkboxes"
//                                                                 ></label>
//                                                             </label>
//                                                         </li>
//                                                     ))}
//                                                 </ul>
//                                             </Collapse>
//                                         </div>

//                                         {/* Price Range Filter */}
//                                         <div className="price-filter">
//                                             <h3
//                                                 className="price-filter-text"
//                                                 role="button"
//                                                 onClick={() => setOpenPrice(!openPrice)}
//                                             >
//                                                 Package Price <i className={openPrice ? "fa fa-minus" : "fa fa-plus"}></i>
//                                             </h3>

//                                             <Collapse in={openPrice}>
//                                                 <div className="p-2">
//                                                     <div className="d-flex justify-content-between mb-5">
//                                                         <span className="text-muted small">$0</span>
//                                                         <span className="text-muted small">${initialMaxPriceLimit}</span>
//                                                     </div>

//                                                     <RangeSlider
//                                                         min={0}
//                                                         max={initialMaxPriceLimit}
//                                                         step={1}
//                                                         value={[Number(minPrice) || 0, Number(maxPrice) || initialMaxPriceLimit]}
//                                                         onChange={([min, max]) => {
//                                                             setMinPrice(min);
//                                                             setMaxPrice(max);
//                                                         }}
//                                                         tooltip={true}
//                                                     />
//                                                 </div>
//                                             </Collapse>
//                                         </div>

//                                         <p className="filter-note">
//                                             After making your selections, click <strong>"Apply Filter"</strong> to update the results.
//                                         </p>

//                                         <div className="price-filter filter-button">
//                                             <div>
//                                                 <button className='btn btn-danger' onClick={applyFilters}>APPLY FILTER</button>
//                                             </div>
//                                         </div>
//                                     </>
//                                 ) : (
//                                     <>
//                                         {/* Tire Brand Filter */}
//                                         <div className="price-filter">
//                                             <h3
//                                                 className="price-filter-text"
//                                                 role="button"
//                                                 onClick={() => setOpenTireBrand(!openTireBrand)}
//                                             >
//                                                 Tire Brand <i className={openTireBrand ? "fa fa-minus" : "fa fa-plus"}></i>
//                                             </h3>

//                                             {/* <Collapse in={openTireBrand}>
//                                                 <ul className="p-0 m-0 list-filter">

//                                                     {availableTireBrands.length > 0 ? (
//                                                         availableTireBrands.map((brandObj) => (
//                                                             <li key={brandObj.brand_id}>
//                                                                 <label className="label-filter">

//                                                                     <input
//                                                                         type="checkbox"
//                                                                         id={`tire-brand-${brandObj.brand_id}`}
//                                                                         value={brandObj.brand_id}
//                                                                         className="filter-box"
//                                                                         checked={tireBrandArray.includes(String(brandObj.brand_id))}
//                                                                         onChange={handleTireBrandCheckboxChange}
//                                                                     />

//                                                                     {brandObj.brand}

//                                                                     <label
//                                                                         htmlFor={`tire-brand-${brandObj.brand_id}`}
//                                                                         className="custome-checkboxes"
//                                                                     ></label>

//                                                                 </label>
//                                                             </li>
//                                                         ))
//                                                     ) : (
//                                                         <ShimmerThumbnail height={10} rounded />
//                                                     )}

//                                                 </ul>
//                                             </Collapse> */}

//                                             <Collapse in={openTireBrand}>
//                                                 <ul className="p-0 m-0 list-filter">
//                                                     {availableTireBrands.length > 0 ? (
//                                                         availableTireBrands.map((brandObj) => (
//                                                             <li key={brandObj.brand}>
//                                                                 <label className="label-filter">

//                                                                     <input
//                                                                         type="checkbox"
//                                                                         id={`tire-brand-${brandObj.brand}`}
//                                                                         value={brandObj.ids.join(',')}
//                                                                         className="filter-box"
//                                                                         // checked if any ID of this brand is in the selected array
//                                                                         checked={brandObj.ids.some(id => tireBrandArray.includes(String(id)))}
//                                                                         onChange={() => handleTireBrandCheckboxChange(brandObj)}
//                                                                     />

//                                                                     {brandObj.brand}

//                                                                     <label
//                                                                         htmlFor={`tire-brand-${brandObj.brand}`}
//                                                                         className="custome-checkboxes"
//                                                                     ></label>

//                                                                 </label>
//                                                             </li>
//                                                         ))
//                                                     ) : (
//                                                         <ShimmerThumbnail height={10} rounded />
//                                                     )}
//                                                 </ul>
//                                             </Collapse>


//                                         </div>

//                                         {/* Tire Model Filter */}
//                                         <div className="price-filter">
//                                             <h3
//                                                 className="price-filter-text"
//                                                 role="button"
//                                                 onClick={() => setOpenTireModel(!openTireModel)}
//                                             >
//                                                 Tire Model <i className={openTireModel ? "fa fa-minus" : "fa fa-plus"}></i>
//                                             </h3>

//                                             <Collapse in={openTireModel}>
//                                                 <ul className="p-0 m-0 list-filter">
//                                                     {availableTireModels.map((model) => (
//                                                         <li key={model}>
//                                                             <label className="label-filter">

//                                                                 <input
//                                                                     type="checkbox"
//                                                                     id={`tire-model-${model}`}
//                                                                     value={model}
//                                                                     checked={tireModelArray.includes(model)}
//                                                                     onChange={handleTireModelCheckboxChange}
//                                                                     className="filter-box"
//                                                                 />

//                                                                 {formatTitleName(model)}

//                                                                 <label
//                                                                     htmlFor={`tire-model-${model}`}
//                                                                     className="custome-checkboxes"
//                                                                 ></label>

//                                                             </label>
//                                                         </li>
//                                                     ))}
//                                                 </ul>
//                                             </Collapse>
//                                         </div>

//                                         {/* Tire Size Filter */}
//                                         <div className="price-filter">
//                                             <h3
//                                                 className="price-filter-text"
//                                                 role="button"
//                                                 onClick={() => setOpenTireSize(!openTireSize)}
//                                             >
//                                                 Tire Size <i className={openTireSize ? "fa fa-minus" : "fa fa-plus"}></i>
//                                             </h3>

//                                             <Collapse in={openTireSize}>
//                                                 <ul className="p-0 m-0 list-filter">
//                                                     {availableTireSizes.length > 0 ? (
//                                                         availableTireSizes.map((size) => (
//                                                             <li key={size}>
//                                                                 <label className="label-filter">
//                                                                     <input
//                                                                         type="checkbox"
//                                                                         id={`tire-size-${size}`}
//                                                                         value={size}
//                                                                         className="filter-box"
//                                                                         checked={tireSizeArray.includes(size)}
//                                                                         onChange={handleTireSizeChange}
//                                                                     />
//                                                                     {size}
//                                                                     <label
//                                                                         htmlFor={`tire-size-${size}`}
//                                                                         className="custome-checkboxes"
//                                                                     ></label>
//                                                                 </label>
//                                                             </li>
//                                                         ))
//                                                     ) : (
//                                                         <ShimmerThumbnail height={10} rounded />
//                                                     )}
//                                                 </ul>
//                                             </Collapse>
//                                         </div>

//                                         <div className="price-filter">
//                                             <h3
//                                                 className="price-filter-text"
//                                                 role="button"
//                                                 onClick={() => setOpenTirePrice(!openTirePrice)}
//                                             >
//                                                 Tire Price <i className={openTirePrice ? "fa fa-minus" : "fa fa-plus"}></i>
//                                             </h3>

//                                             <Collapse in={openTirePrice}>
//                                                 <div className="p-2">
//                                                     <div className="d-flex justify-content-between mb-5">
//                                                         <span className="text-muted small">$0</span>
//                                                         <span className="text-muted small">${maxTirePriceLimit}</span>
//                                                     </div>

//                                                     <RangeSlider
//                                                         min={0}
//                                                         max={maxTirePriceLimit}
//                                                         step={1}
//                                                         value={[Number(minTirePrice) || 0, Number(maxTirePrice) || maxTirePriceLimit]}
//                                                         onChange={handleTirePriceRangeChange}
//                                                         tooltip={true}
//                                                     />

//                                                 </div>
//                                             </Collapse>
//                                         </div>

//                                         <p className="filter-note">
//                                             After making your selections, click <strong>"Apply Filter"</strong> to update the results.
//                                         </p>

//                                         <div className="price-filter filter-button">
//                                             <div>
//                                                 <button className='btn btn-danger' onClick={applyFilters}>APPLY FILTER</button>
//                                             </div>
//                                         </div>


//                                     </>
//                                 )}


//                             </div>
//                         </div>

//                         {/* Main Content */}
//                         <div className="col-lg-9 filter-for-mobile">

//                             <div className='selectedFilters mb-3'>

//                                 {/* ================= NORMAL FILTER CHIPS ================= */}
//                                 {!isUpgradeMode && (
//                                     <>
//                                         {/* Diameter Chips */}
//                                         {diameterArray.map(dia => (
//                                             <span className="span-filter-Checkbox m-1" key={dia}>
//                                                 {dia + '"'}
//                                                 <i
//                                                     className="fa fa-times"
//                                                     onClick={() =>
//                                                         setDiameterArray(prev => prev.filter(d => d !== dia))
//                                                     }
//                                                 ></i>
//                                             </span>
//                                         ))}

//                                         {/* Brand Chips */}
//                                         {brandArray.map((brandId) => {
//                                             const brandObj = availableBrands.find(
//                                                 b => String(b.brand_id) === String(brandId)
//                                             );

//                                             return (
//                                                 <span className="span-filter-Checkbox m-1" key={brandId}>
//                                                     {brandObj?.brand_desc}

//                                                     <i
//                                                         className="fa fa-times"
//                                                         onClick={() =>
//                                                             setBrandArray(prev =>
//                                                                 prev.filter(b => b !== brandId)
//                                                             )
//                                                         }
//                                                     ></i>
//                                                 </span>
//                                             );
//                                         })}


//                                         {/* Model Chips */}
//                                         {modelArray.map(mod => (
//                                             <span className="span-filter-Checkbox m-1" key={mod}>
//                                                 {mod}

//                                                 <i
//                                                     className="fa fa-times"
//                                                     onClick={() =>
//                                                         setModelArray(prev =>
//                                                             prev.filter(m => m !== mod)
//                                                         )
//                                                     }
//                                                 ></i>
//                                             </span>
//                                         ))}

//                                         {/* Width Chips */}
//                                         {widthArray.map(w => (
//                                             <span className="span-filter-Checkbox m-1" key={w}>
//                                                 {w}
//                                                 <i className="fa fa-times" onClick={() => setWidthArray(prev => prev.filter(ww => ww !== w))}></i>
//                                             </span>
//                                         ))}

//                                         {/* Offset Chips */}
//                                         {/* {offsetArray.map(off => (
//                                             <span className="span-filter-Checkbox m-1" key={off}>
//                                                 {off}
//                                                 <i className="fa fa-times" onClick={() => setOffsetArray(prev => prev.filter(o => o !== off))}></i>
//                                             </span>
//                                         ))} */}

//                                         {offsetArray.map(cat => (
//                                             <span className="span-filter-Checkbox m-1" key={cat}>
//                                                 {cat === 'negative' && 'Negative'}
//                                                 {cat === 'low' && 'Low (0-15)'}
//                                                 {cat === 'medium' && 'Medium (15-30)'}
//                                                 {cat === 'high' && 'High (30-45)'}
//                                                 {cat === 'veryHigh' && 'Very High (45+)'}
//                                                 <i
//                                                     className="fa fa-times"
//                                                     onClick={() => setOffsetArray(prev => prev.filter(c => c !== cat))}
//                                                 ></i>
//                                             </span>
//                                         ))}

//                                         {/* Color Chips */}
//                                         {colorArray.map(color => (
//                                             <span className="span-filter-Checkbox m-1" key={color}>
//                                                 {color}
//                                                 <i className="fa fa-times" onClick={() => setColorArray(prev => prev.filter(c => c !== color))}></i>
//                                             </span>
//                                         ))}
//                                     </>
//                                 )}

//                                 {/* ================= TIRE FILTER CHIPS ================= */}
//                                 {isUpgradeMode && (
//                                     <>
//                                         {/* Tire Brand Chips */}
//                                         {/* {tireBrandArray.map((brandId) => {

//                                             const brandObj = availableTireBrands.find(
//                                                 b => String(b.brand_id) === String(brandId)
//                                             );

//                                             return (
//                                                 <span className="span-filter-Checkbox m-1" key={brandId}>

//                                                     {brandObj?.brand}

//                                                     <i
//                                                         className="fa fa-times"
//                                                         onClick={() =>
//                                                             setTireBrandArray(prev =>
//                                                                 prev.filter(b => b !== brandId)
//                                                             )
//                                                         }
//                                                     ></i>

//                                                 </span>
//                                             );
//                                         })} */}

//                                         {tireBrandArray.length > 0 &&
//                                             availableTireBrands
//                                                 .filter(b => b.ids.some(id => tireBrandArray.includes(String(id))))
//                                                 .map(brandObj => (
//                                                     <span className="span-filter-Checkbox m-1" key={brandObj.brand}>
//                                                         {brandObj.brand}
//                                                         <i
//                                                             className="fa fa-times"
//                                                             onClick={() =>
//                                                                 setTireBrandArray(prev =>
//                                                                     prev.filter(id => !brandObj.ids.map(String).includes(id))
//                                                                 )
//                                                             }
//                                                         ></i>
//                                                     </span>
//                                                 ))
//                                         }

//                                         {/* Tire Model Chips */}
//                                         {tireModelArray.map((model) => (
//                                             <span className="span-filter-Checkbox m-1" key={model}>
//                                                 {formatTitleName(model)}

//                                                 <i
//                                                     className="fa fa-times"
//                                                     onClick={() =>
//                                                         setTireModelArray(prev =>
//                                                             prev.filter(m => m !== model)
//                                                         )
//                                                     }
//                                                 ></i>
//                                             </span>
//                                         ))}

//                                         {tireSizeArray.map((size) => (
//                                             <span className="span-filter-Checkbox m-1" key={size}>
//                                                 {size}
//                                                 <i className="fa fa-times" onClick={() => setTireSizeArray(prev => prev.filter(s => s !== size))}></i>
//                                             </span>
//                                         ))}
//                                     </>
//                                 )}

//                                 {/* ================= CLEAR FILTER ================= */}
//                                 {(
//                                     (!isUpgradeMode &&
//                                         (
//                                             diameterArray.length > 0 ||
//                                             brandArray.length > 0 ||
//                                             modelArray.length > 0 ||
//                                             widthArray.length > 0 ||
//                                             offsetArray.length > 0 ||
//                                             colorArray.length > 0
//                                         )
//                                     ) ||
//                                     (isUpgradeMode &&
//                                         (
//                                             tireBrandArray.length > 0 ||
//                                             tireModelArray.length > 0 ||
//                                             tireSizeArray.length > 0
//                                         )
//                                     )
//                                 ) && (
//                                         <span
//                                             className="clearFilterStyle ms-2"
//                                             onClick={clearAllFilters}
//                                         >
//                                             Clear filters
//                                         </span>
//                                     )}
//                             </div>

//                             {/* Sort & Stock Controls */}
//                             <div className="d-flex justify-content-end filters-sort-by">
//                                 <div>
//                                     {totalProducts > 0 && !isUpgradeMode && (
//                                         <p className="px-5">
//                                             Showing {startIndex} - {endIndex} of {parseInt(totalProducts).toLocaleString('en-US')} packages
//                                         </p>
//                                     )}
//                                 </div>

//                                 {/* <div className="stockCheckbox">
//                                     <ul className="stockCheckboxUl">
//                                         <li>
//                                             <input
//                                                 type="checkbox"
//                                                 className="tgl tgl-light"
//                                                 id="stockCheckPackage"
//                                                 checked={!showInStockOnly}
//                                                 onChange={handleStockToggle}
//                                             />
//                                             <label htmlFor="stockCheckPackage" className="tgl-btn"></label>
//                                         </li>
//                                         <li className="staggeredLi">
//                                             {showInStockOnly ? <span>In Stock Items</span> : <span>All Items</span>}
//                                         </li>
//                                     </ul>
//                                 </div> */}

//                                 {/* <div className="sorting-section">
//                                     <select className="form-control" value={sortingValue} onChange={handleSorting}>
//                                         <option value={1}>Low-High</option>
//                                         <option value={2}>High-Low</option>
//                                     </select>
//                                 </div> */}

//                                 {!isUpgradeMode && (
//                                     <div className="sorting-section">
//                                         <select className="form-control" value={sortingValue} onChange={handleSorting}>
//                                             <option value={1}>Low-High</option>
//                                             <option value={2}>High-Low</option>
//                                         </select>
//                                     </div>
//                                 )}

//                                 <div className="main-headin">
//                                     <div className="main-filter-resposive">
//                                         <button className="mobile-filter-btn" onClick={showFiltersClick}> <svg className="me-1" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" key="svg-icon">
//                                             <path d="M5.25901 14.35L5.25888 14.35C5.24769 14.3502 5.23405 14.3476 5.21863 14.339L5.21836 14.3389C5.19936 14.3282 5.19074 14.318 5.18703 14.3124C5.17887 14.2972 5.176 14.2839 5.176 14.2707V7.91365C5.176 7.82275 5.1652 7.72056 5.13235 7.61486C5.09945 7.50839 5.04961 7.41561 4.99386 7.33726L0.724519 1.26892C0.724485 1.26887 0.724451 1.26882 0.724418 1.26877C0.676725 1.20083 0.65495 1.13291 0.650688 1.06991C0.64665 1.00345 0.660203 0.933143 0.696549 0.863781L0.696552 0.863774C0.732993 0.794228 0.783357 0.74264 0.84197 0.707465L0.841971 0.707466L0.843135 0.706765C0.902543 0.670943 0.973036 0.65 1.05357 0.65H12.9463C13.0271 0.65 13.0973 0.670932 13.1564 0.706609L13.1578 0.70745C13.2164 0.742594 13.2667 0.794096 13.3032 0.863535C13.3407 0.935416 13.3534 1.00516 13.3492 1.06874C13.345 1.13245 13.3232 1.20066 13.2755 1.26862C13.2755 1.26872 13.2754 1.26882 13.2753 1.26892L9.0045 7.33779L9.00402 7.33848C8.94618 7.42089 8.90098 7.51067 8.86985 7.6068L8.86979 7.60678L8.8672 7.61518C8.83481 7.71999 8.82355 7.82177 8.82355 7.91441V12.1555C8.82355 12.1724 8.81984 12.1838 8.81525 12.1923C8.81075 12.1999 8.8025 12.2101 8.78506 12.2207L8.34805 12.4857L8.34827 12.4864L5.3042 14.3361C5.30409 14.3362 5.30399 14.3362 5.30388 14.3363C5.28736 14.3462 5.27261 14.3497 5.25901 14.35ZM5.27154 14.9999C5.14389 15.0023 5.01635 14.9707 4.90099 14.9061L5.27154 14.9999Z" stroke="#E81C2E" strokeWidth="1.3"></path>
//                                         </svg>
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>



//                             {/* Packages Grid */}
//                             {/* <div className="row">
//                                 {isLoading ? (
//                                     Array.from({ length: 6 }).map((_, i) => (
//                                         <div className="col-lg-6 col-md-12 mb-4" key={i}>
//                                             <ShimmerThumbnail height={300} rounded />
//                                         </div>
//                                     ))
//                                 ) : packages.length > 0 ? (
//                                     packages.map((pkg, index) => (
//                                         <div className="col-lg-6 col-md-12 mb-4" key={getPackageKey(pkg, index)}>
//                                             <WheelTirePackageCard
//                                                 packageData={pkg}
//                                                 enableUpgradeMode={enableUpgradeMode}
//                                                 isUpgradeMode={isUpgradeMode}
//                                             />
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <div className='container m-0 text-center py-5'>
//                                         <h1>No Product Found</h1>
//                                         <p>Sorry, we couldn't find any Wheel & Tire Packages.</p>
//                                         <p><a href='/' className='btn btn-sm btn-danger'>Go to Homepage</a></p>
//                                     </div>
//                                 )}
//                             </div> */}

//                             <div className="row">
//                                 {isLoading ? (

//                                     Array.from({ length: 6 }).map((_, i) => (
//                                         <div className="col-lg-6 col-md-12 mb-4" key={i}>
//                                             <ShimmerThumbnail height={300} rounded />
//                                         </div>
//                                     ))

//                                 ) : (

//                                     !isUpgradeMode ? (

//                                         packages.length > 0 ? (

//                                             packages.map((pkg, index) => (
//                                                 <div
//                                                     className="col-lg-6 col-md-12 mb-4"
//                                                     key={getPackageKey(pkg, index)}
//                                                 >
//                                                     <WheelTirePackageCard
//                                                         packageData={pkg}
//                                                         enableUpgradeMode={enableUpgradeMode}
//                                                         isUpgradeMode={false}
//                                                     />
//                                                 </div>
//                                             ))

//                                         ) : (

//                                             <div className="container m-0 text-center py-5">
//                                                 <h1>No Product Found</h1>
//                                                 <p>Sorry, we couldn't find any Wheel & Tire Packages.</p>
//                                                 <p>
//                                                     <a href="/" className="btn btn-sm btn-danger">
//                                                         Go to Homepage
//                                                     </a>
//                                                 </p>
//                                             </div>

//                                         )

//                                     ) : (

//                                         upgradedPackages.length > 0 ? (

//                                             upgradedPackages.map((pkg, index) => (
//                                                 <div
//                                                     className="col-lg-12 mb-4"
//                                                     key={`${pkg.wheel.sku}-${index}`}
//                                                 >
//                                                     <UpgradeTirePackageCard
//                                                         packageData={pkg}
//                                                         isUpgradeMode={true}
//                                                     />
//                                                 </div>
//                                             ))

//                                         ) : (

//                                             <div className="container m-0 text-center py-5">
//                                                 <h1>No Product Found</h1>
//                                                 <p>Sorry, we couldn't find any Upgrade Tire Packages.</p>
//                                                 <p>
//                                                     <a href="/" className="btn btn-sm btn-danger">
//                                                         Go to Homepage
//                                                     </a>
//                                                 </p>
//                                             </div>

//                                         )

//                                     )

//                                 )}
//                             </div>

//                             {/* Pagination */}
//                             {!isUpgradeMode && totalPages > 1 && (
//                                 <div className="d-flex justify-content-center mt-5">
//                                     <Pagination>
//                                         <Pagination.First disabled={currentPage === 1} onClick={() => handlePageChange(1)} />
//                                         <Pagination.Prev disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)} />
//                                         {getPageNumbers().map(page => (
//                                             <Pagination.Item
//                                                 key={page}
//                                                 active={page === currentPage}
//                                                 onClick={() => handlePageChange(page)}
//                                             >
//                                                 {page}
//                                             </Pagination.Item>
//                                         ))}
//                                         <Pagination.Next disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)} />
//                                         <Pagination.Last disabled={currentPage === totalPages} onClick={() => handlePageChange(totalPages)} />
//                                     </Pagination>
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             <FOOTER />
//         </>
//     );
// }